<template>
  <div :id="content.idHTML" :class="jel_getClassObject(content)">
    <div
      v-if="isSpinnerVisible"
      id="spinner"
      class="spinner-fullscreen d-flex flex-column justify-content-center align-items-center text-center"
    >
      <div
        class="spinner-card d-flex flex-column align-items-center justify-content-center text-center px-4 py-4"
      >
        <div
          class="spinner-card-text graphik_semibold mb-3"
          v-html="spinnerLongWait ? $t('messageComponent.spinnerAchalandage') : $t('chargement')"
        ></div>
        <b-spinner :label="$t('chargement')"></b-spinner>
      </div>
    </div>

    <Titre :content="contentTitreDepot"></Titre>

    <MessageMel
      v-show="contentMessageMel.message"
      :content="contentMessageMel"
      class="mt-n1 mt-md-0 mb-1 ml-md-0"
    ></MessageMel>

    <!-- ******* -->
    <!-- ACCUEIL -->
    <!-- ******* -->
    <div v-show="!methodePaiement">
      <div class="row">
        <div class="col ml-0">
          <div v-if="contentTxtHaut" class="mt-2 mb-1" v-html="contentTxtHaut"></div>
          <b-form-group class="ml-0 mb-0">
            <!-- tag="div" nécessaire pour accessibilité, éviter div dans un span -->
            <span
              class="texte texte-padding mt-0 graphik_regular"
              label-for="methodePaiement"
              v-html="content.libModeDePaiement"
            >
            </span>
            <div class="mt-1" plain name="methodePaiement">
              <div
                :disabled="isCreditCardDisabled"
                class="customRadio radio-depot encadrer"
                @click.prevent="
                  !isCreditCardDisabled && changeMethodePaiement(CONSTANT.methodePaiement.card)
                "
              >
                <div class="d-flex">
                  <div class="texte-radio-btn-depot d-inline-block w-65">
                    <div class="graphik_semibold my-0" v-html="content.libCarteCredit"></div>
                    <span
                      v-if="content.libCarteCredit2"
                      class="note graphik_regular"
                      v-html="content.libCarteCredit2"
                    ></span>
                  </div>
                  <div class="image-container d-inline-block w-35">
                    <svg-icon
                      aria-label="Visa"
                      class="svg-icon-visa mt-0"
                      :icon-name="isCreditCardDisabled ? 'card-visa-gris' : 'card-visa'"
                    ></svg-icon>
                    <svg-icon
                      aria-label="Mastercard"
                      class="svg-icon-mc mt-0"
                      :icon-name="isCreditCardDisabled ? 'card-mastercard-gris' : 'card-mastercard'"
                    ></svg-icon>
                    <svg-icon
                      aria-label="American Express"
                      class="svg-icon-amex mt-0"
                      :icon-name="isCreditCardDisabled ? 'card-amex-gris' : 'card-amex'"
                    ></svg-icon>
                  </div>
                </div>
                <Separateur class="mx-0 my-1"></Separateur>
                <div class="d-flex">
                  <div class="texte-radio-btn-depot d-inline-block w-65">
                    <div class="graphik_semibold my-0" v-html="content.libCarteDebit"></div>
                    <span
                      v-if="content.libCarteDebit2"
                      class="note graphik_regular"
                      v-html="content.libCarteDebit2"
                    ></span>
                  </div>
                  <div class="image-container d-inline-block w-35">
                    <svg-icon
                      aria-label="Visa"
                      class="svg-icon-visa mt-0"
                      :icon-name="isCreditCardDisabled ? 'card-visa-gris' : 'card-visa'"
                    ></svg-icon>
                    <svg-icon
                      aria-label="Mastercard"
                      class="svg-icon-mc mt-0"
                      :icon-name="isCreditCardDisabled ? 'card-mastercard-gris' : 'card-mastercard'"
                    ></svg-icon>
                  </div>
                </div>
                <ErreurValidation
                  v-if="!isErreurServeur && messageErreurCreditCard"
                  id="choix-depot-invalid-feedback"
                  classesCSS="mx-0"
                  :message="messageErreurCreditCard"
                ></ErreurValidation>
              </div>
              <template>
                <v-popover
                  v-show="isTooltipVirementInteracVisible"
                  trigger="manual"
                  :open="isTooltipVirementInteracVisible"
                  offset="25px"
                  :auto-hide="false"
                  placement="top-start"
                  container="form"
                  class="pl-1"
                  shadow-sm
                >
                  <template slot="popover">
                    <div class="d-flex flex-row justify-content-between">
                      <button
                        class="close py-0 pl-1 pr-0 mb-2"
                        @click.prevent="cacherTooltip('VirementInterac')"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <Paragraphe
                      :content="{
                        richText: content.txtBulleVirementInterac,
                      }"
                      class="texte-tooltip ml-2 mr-2 mt-2"
                    ></Paragraphe>
                    <Hyperlien
                      v-if="contentLienAideBulleVirementInterac"
                      class="lien-aide ml-2 mr-2 mb-2"
                      :content="contentLienAideBulleVirementInterac"
                    ></Hyperlien>
                  </template>
                </v-popover>
              </template>

              <!-- Virement Interac -->

              <div
                :disabled="iseTransferLimiteReached"
                class="customRadio encadrer radio-depot"
                @click.prevent="
                  !iseTransferLimiteReached && changeMethodePaiement(CONSTANT.methodePaiement.et)
                "
              >
                <div class="d-flex">
                  <div class="texte-radio-btn-depot d-inline-block w-65">
                    <div class="graphik_semibold" v-html="content.libVirementInterac"></div>
                    <span
                      v-if="content.libVirementInterac2"
                      class="note graphik_regular"
                      v-html="content.libVirementInterac2"
                    ></span>
                  </div>
                  <div class="image-container d-inline-block w-35">
                    <svg-icon
                      aria-label="Interac"
                      class="svg-icon-interac mr-0 mt-0"
                      :icon-name="iseTransferLimiteReached ? 'logo-Interac-gris' : 'logo-Interac'"
                    ></svg-icon>
                  </div>
                </div>
              </div>

              <!-- Apple Pay -->
              <template>
                <v-popover
                  v-show="isTooltipApplePayVisible"
                  v-if="jel_applePayActif()"
                  trigger="manual"
                  :open="isTooltipApplePayVisible"
                  offset="25px"
                  :auto-hide="false"
                  placement="top-start"
                  container="form"
                  class="pl-1"
                  shadow-sm
                >
                  <template slot="popover">
                    <div class="d-flex flex-row justify-content-between">
                      <button
                        class="close py-0 pl-1 pr-0 mb-2"
                        @click.prevent="cacherTooltip('ApplePay')"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <Paragraphe
                      :content="{
                        richText: content.txtBulleApplePay,
                      }"
                      class="texte-tooltip ml-2 mr-2 mt-2"
                    ></Paragraphe>
                    <Hyperlien
                      v-if="contentLienAideBulleApplePay"
                      class="lien-aide ml-2 mr-2 mb-2"
                      :content="contentLienAideBulleApplePay"
                    ></Hyperlien>
                  </template>
                </v-popover>
              </template>

              <div
                v-if="jel_applePayActif()"
                :disabled="isApplePayDisabled"
                class="customRadio encadrer radio-depot"
                @click.prevent="
                  !isApplePayDisabled && changeMethodePaiement(CONSTANT.methodePaiement.ap)
                "
              >
                <div class="d-flex">
                  <div class="texte-radio-btn-depot d-inline-block w-65">
                    <div class="graphik_semibold" v-html="content.libApplePay"></div>
                    <span
                      v-if="content.libApplePay2"
                      class="note graphik_regular"
                      v-html="content.libApplePay2"
                    ></span>
                  </div>
                  <div class="image-container d-inline-block w-35">
                    <svg-icon
                      aria-label="Applepay"
                      class="svg-icon-applepay mr-0 mt-0"
                      :icon-name="isApplePayDisabled ? 'logo-applepay-gris' : 'logo-applepay'"
                    ></svg-icon>
                  </div>
                </div>
                <ErreurValidation
                  v-if="!isErreurServeur && messageErreurApplePay"
                  id="choix-depot-invalid-feedback"
                  classesCSS="mx-0"
                  :message="messageErreurApplePay"
                ></ErreurValidation>
              </div>

              <!-- Google Pay -->
              <template v-if="jel_googlePayActif()">
                <v-popover
                  v-show="isTooltipGooglePayVisible"
                  trigger="manual"
                  :open="isTooltipGooglePayVisible"
                  offset="25px"
                  :auto-hide="false"
                  placement="top-start"
                  container="form"
                  class="pl-1"
                  shadow-sm
                >
                  <template slot="popover">
                    <div class="d-flex flex-row justify-content-between">
                      <button
                        class="close py-0 pl-1 pr-0 mb-2"
                        @click.prevent="cacherTooltip('GooglePay')"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <Paragraphe
                      :content="{
                        richText: content.txtBulleGooglePay,
                      }"
                      class="texte-tooltip ml-2 mr-2 mt-2"
                    ></Paragraphe>
                    <Hyperlien
                      v-if="contentLienAideBulleGooglePay"
                      class="lien-aide ml-2 mr-2 mb-2"
                      :content="contentLienAideBulleGooglePay"
                    ></Hyperlien>
                  </template>
                </v-popover>
              </template>

              <div
                v-if="jel_googlePayActif()"
                :disabled="isGooglePayDisabled"
                class="customRadio encadrer radio-depot"
                @click.prevent="
                  !isGooglePayDisabled && changeMethodePaiement(CONSTANT.methodePaiement.gp)
                "
              >
                <div class="d-flex">
                  <div class="texte-radio-btn-depot d-inline-block w-65">
                    <div class="graphik_semibold" v-html="content.libGooglePay"></div>
                    <span
                      v-if="content.libGooglePay2"
                      class="note graphik_regular"
                      v-html="content.libGooglePay2"
                    ></span>
                  </div>
                  <div class="image-container d-inline-block w-35">
                    <svg-icon
                      aria-label="Googlepay"
                      class="svg-icon-googlepay mr-0 mt-0"
                      :icon-name="isGooglePayDisabled ? 'logo-googlepay-gris' : 'logo-googlepay'"
                    ></svg-icon>
                  </div>
                </div>
                <ErreurValidation
                  v-if="!isErreurServeur && messageErreurGooglePay"
                  id="choix-depot-invalid-feedback"
                  classesCSS="mx-0"
                  :message="messageErreurGooglePay"
                ></ErreurValidation>
              </div>

              <!-- ARGENT WEB -->
              <div
                v-if="jel_argentWebActif()"
                :disabled="isArgentWebDisabled"
                class="customRadio encadrer radio-depot"
                @click.prevent="
                  !isArgentWebDisabled && changeMethodePaiement(CONSTANT.methodePaiement.argentWeb)
                "
              >
                <div class="d-flex">
                  <div class="texte-radio-btn-depot d-inline-block w-65">
                    <div class="graphik_semibold">
                      <Hyperlien
                        class="rem-style"
                        :disabled="isArgentWebDisabled"
                        :content="contentLienCouponArgentWeb"
                      ></Hyperlien>
                    </div>
                  </div>
                  <div v-if="inAppMobile" class="image-container d-inline-block w-35">
                    <svg-icon
                      aria-label="Argentweb"
                      class="svg-icon-argentweb mr-0 mt-0"
                      :icon-name="isArgentWebDisabled ? 'qr-code-gris' : 'qr-code'"
                    ></svg-icon>
                  </div>

                  <div v-else class="image-container d-inline-block w-35">
                    <svg-icon
                      aria-label="Argentweb"
                      class="svg-icon-argentweb mr-0 mt-0"
                      :icon-name="isArgentWebDisabled ? 'im-argent-web-gris' : 'im-argent-web'"
                    ></svg-icon>
                  </div>
                </div>
                <ErreurValidation
                  v-if="!isErreurServeur && messageErreurArgentWeb"
                  id="choix-depot-invalid-feedback"
                  classesCSS="mx-0"
                  :message="messageErreurArgentWeb"
                  :variables="variablesRemplacementArgentWeb"
                ></ErreurValidation>
              </div>

              <!-- PAIEMENT FACTURES -->
              <div
                v-if="jel_paiementFacturesActif()"
                :disabled="isPaiementFacturesDisabled"
                class="customRadio encadrer radio-depot"
                @click.prevent="
                  !isPaiementFacturesDisabled &&
                    changeMethodePaiement(CONSTANT.methodePaiement.paiementFactures)
                "
              >
                <div class="d-flex">
                  <div class="texte-radio-btn-depot d-inline-block w-90">
                    <div class="graphik_semibold">
                      <Hyperlien
                        class="rem-style"
                        :disabled="isErreurServeur"
                        :content="contentLienPaiementFactures"
                      ></Hyperlien>
                    </div>
                  </div>
                  <div class="image-container d-inline-block w-10">
                    <svg-icon
                      aria-label="Paiementfactures"
                      class="svg-icon-paiementfactures mr-0 mt-0"
                      :icon-name="
                        isPaiementFacturesDisabled ? 'icone-facture' : 'icone-facture-gris'
                      "
                    ></svg-icon>
                  </div>
                </div>
              </div>
            </div>
          </b-form-group>

          <div v-if="contentTxtBas" class="mt-3 mb-0" v-html="contentTxtBas"></div>
        </div>
      </div>
    </div>

    <!-- ****************** -->
    <!-- Carte Crédit/Débit -->
    <!-- Virement INTERAC   -->
    <!-- INTERAC en ligne   -->
    <!-- ****************** -->
    <ValidationObserver
      v-show="
        [
          CONSTANT.methodePaiement.card.paymentMethod,
          CONSTANT.methodePaiement.et.paymentMethod,
          CONSTANT.methodePaiement.ap.paymentMethod,
          CONSTANT.methodePaiement.gp.paymentMethod,
        ].includes(methodePaiement)
      "
      ref="observer"
      v-slot="{ handleSubmit, invalid }"
      tag="div"
    >
      <!-- Carte Crédit/Débit -->
      <div
        v-if="methodePaiement === CONSTANT.methodePaiement.card.paymentMethod"
        class="big-image-container text-md-left text-center"
      >
        <svg-icon aria-label="Visa" class="svg-big-icon-visa mt-0" icon-name="card-visa"></svg-icon>
        <svg-icon
          aria-label="Mastercard"
          class="svg-big-icon-mc mt-0 ml-2"
          icon-name="card-mastercard"
        ></svg-icon>
        <svg-icon
          aria-label="American Express"
          class="svg-big-icon-amex mt-0 ml-2"
          icon-name="card-amex"
        ></svg-icon>
        <Hyperlien
          v-if="contentLienAideCredit"
          class="lien-aide ml-0 mt-0 mr-0"
          :content="contentLienAideCredit"
        ></Hyperlien>
      </div>

      <!-- Virement INTERAC -->
      <div
        v-else-if="methodePaiement === CONSTANT.methodePaiement.et.paymentMethod"
        class="big-image-container text-md-left text-center"
      >
        <svg-icon
          aria-label="Interac"
          class="svg-icon-big mr-0 mt-0"
          icon-name="logo-Interac"
        ></svg-icon>
      </div>

      <!-- Apple Pay -->
      <div
        v-else-if="methodePaiement === CONSTANT.methodePaiement.ap.paymentMethod"
        class="big-image-container text-md-left text-center"
      >
        <svg-icon
          aria-label="ApplePay"
          class="svg-icon-applepay-big mr-0 mt-2"
          icon-name="logo-applepay"
        ></svg-icon>
        <Hyperlien
          v-if="contentLienAideApplePay"
          class="lien-aide mx-0 mt-1"
          :content="contentLienAideApplePay"
        ></Hyperlien>
      </div>

      <!-- Google Pay -->
      <div
        v-else-if="methodePaiement === CONSTANT.methodePaiement.gp.paymentMethod"
        class="big-image-container text-md-left text-center"
      >
        <svg-icon
          aria-label="GooglePay"
          class="svg-icon-googlepay-big mr-0 mt-2"
          icon-name="logo-googlepay"
        ></svg-icon>
        <Hyperlien
          v-if="contentLienAideGooglePay"
          class="lien-aide mx-0 mt-1"
          :content="contentLienAideGooglePay"
        ></Hyperlien>
      </div>

      <!-- INTERAC en ligne -->
      <div v-else class="big-image-container text-md-left text-center">
        <svg-icon
          aria-label="Interac"
          class="svg-icon-big mr-1 mt-0"
          icon-name="logo-Interac"
        ></svg-icon>
        <span v-html="$t('messageComponent.avec')"></span>
        <svg-icon
          aria-label="TD Canada Trust"
          class="svg-icon-small ml-1 mr-0 mt-0"
          icon-name="TD"
        ></svg-icon>
      </div>

      <b-form class="mt-5" @submit.stop.prevent="handleSubmit(onSubmit)">
        <div v-if="contentTxtHaut" class="mt-0 mb-0" v-html="contentTxtHaut"></div>
        <ValidationProvider
          v-slot="{ errors }"
          name="amount"
          :rules="`${
            methodePaiement === CONSTANT.methodePaiement.ap.paymentMethod ? 'required|' : ''
          }is_depot_valid:${depotMinimum},${depotMaximum}`"
        >
          <b-form-group class="ml-2">
            <div class="row">
              <div v-if="$i18n.locale == 'en'">
                <legend class="texte texte-padding mt-2 mr-1">
                  <span v-html="content.libMontantDepot"></span>
                  <span
                    class="texte graphik_regular"
                    v-html="'($20&nbsp;' + content.libMinimum + ')'"
                  ></span>
                </legend>
              </div>
              <div v-else>
                <legend class="texte texte-padding mt-2 mr-1">
                  <span v-html="content.libMontantDepot"></span>
                  <span
                    class="texte graphik_regular"
                    v-html="'(' + content.libMinimum + '&nbsp;20&nbsp;$)'"
                  ></span>
                </legend>
              </div>
            </div>
            <div class="row col-8 col-md-5 px-0">
              <b-form-input
                id="montant"
                ref="inputMontant"
                v-model="montant"
                :aria-label="content.libMontantDepot"
                name="montant"
                type="text"
                inputmode="decimal"
                maxLength="7"
                autocomplete="off"
                class="grandTexte graphik_regular text-left px-1"
                :class="{
                  'is-invalid': errors.length > 0, // Attention si on ne met pas ceci les erreurs n'aparaissent pas pour v-money...
                }"
                @keypress="onlyNumbers($event)"
                @blur.native="forceValidate()"
              ></b-form-input>
            </div>
            <div class="row">
              <!-- On n'affiche pas le message d'erreur MSG00-03("Le champs est obligatoire") sur la validation de l'input -->
              <ErreurValidation
                v-if="errors[0]"
                id="montantDepot-invalid-feedback"
                :message="errors[0]"
                :variables="variablesRemplacementMinMax"
              ></ErreurValidation>
            </div>
          </b-form-group>

          <div
            v-if="methodePaiement === CONSTANT.methodePaiement.et.paymentMethod"
            class="encadrer cursor-default"
            :disabled="isETransferDisabled"
          >
            <div
              class="grandTexte font-titre pt-1"
              v-html="content.txtTitreVirementInteracET"
            ></div>
            <ErreurValidation
              v-if="messageErreurETransfer"
              id="choix-depot-invalid-feedback"
              classesCSS="mx-0"
              :message="messageErreurETransfer"
            ></ErreurValidation>
            <div v-else>
              <div v-if="contentTxtBas" class="mt-1 mb-3" v-html="contentTxtBas"></div>
              <div class="d-flex flex-column align-items-center align-items-md-start">
                <b-button
                  v-if="!isApplePayBtnActive()"
                  type="submit"
                  variant="primaire"
                  class="w-auto px-4 py-1 mx-0 mb-2"
                  :disabled="invalid || isSubmitted || !montant || isETransferDisabled"
                  :class="{ valid: !invalid }"
                >
                  <div class="d-inline-flex w-auto">
                    <div v-if="isSubmitted && !isPaiementES" class="mr-1">
                      <b-spinner small :label="$t('chargement')"></b-spinner>
                    </div>
                    <span
                      class="text-white"
                      v-html="
                        methodePaiement === CONSTANT.methodePaiement.et.paymentMethod &&
                        !isSafariWeb
                          ? content.libOuvrirVirementInterac
                          : content.libBoutonContinuer
                      "
                    ></span>
                    <svg-icon
                      v-if="
                        methodePaiement === CONSTANT.methodePaiement.et.paymentMethod &&
                        !isSafariWeb
                      "
                      aria-label="share"
                      class="svg-icon-share ml-4px mr-0"
                      icon-name="ic-share"
                    ></svg-icon>
                  </div>
                </b-button>
              </div>
            </div>
          </div>
          <div
            v-if="methodePaiement === CONSTANT.methodePaiement.et.paymentMethod"
            class="encadrer cursor-default"
            :class="isETransferESDisabled ? 'color-disabled' : ''"
          >
            <div
              class="grandTexte font-titre pt-1"
              :class="isETransferESDisabled ? 'color-disabled' : ''"
              v-html="content.txtTitreVirementInteracES"
            ></div>
            <div>
              <div
                v-if="content.txtVirementInteracES"
                class="mt-1 mb-3"
                :class="isETransferESDisabled ? 'color-disabled' : ''"
                v-html="content.txtVirementInteracES"
              ></div>
              <ErreurValidation
                v-if="messageErreurETransferES"
                id="choix-depot-invalid-feedback"
                classesCSS="mx-0"
                :message="messageErreurETransferES"
              ></ErreurValidation>
              <div
                v-if="esStatus === 'NO' && esPayment.paymentRef"
                class="lienPrimaire cursor-pointer"
                @click="changeMethodePaiement(CONSTANT.methodePaiement.es)"
              >
                {{ content.libInfoVirementInteracDesjardins }}
              </div>
              <div
                v-else-if="esStatus === 'YES' && !isETransferESDisabled"
                class="d-flex flex-column align-items-center align-items-md-start w-fit-content conteneur-btn-desjardins"
              >
                <b-button
                  type="submit"
                  variant="secondaire"
                  class="w-auto px-4 py-1 mx-0 mb-2"
                  :disabled="invalid || isSubmitted || !montant || isETransferESDisabled"
                  :class="{ valid: !invalid }"
                  @click="initierPaiementES()"
                >
                  <div class="d-inline-flex w-auto">
                    <div v-if="isSubmitted && isPaiementES" class="mr-1">
                      <b-spinner small :label="$t('chargement')"></b-spinner>
                    </div>
                    <span v-html="content.libOuvrirVirementInteracDesjardins"></span>
                  </div>
                </b-button>
              </div>
            </div>
          </div>

          <div v-else-if="methodePaiement === CONSTANT.methodePaiement.gp.paymentMethod">
            <div class="d-flex flex-column align-items-center align-items-md-start">
              <iframe
                v-show="isGooglePayBtnActive()"
                id="iframePaysafeGP"
                :key="'gp-' + methodePaiement"
                title="iFrame Paysafe GP"
                :src="iframeSrcGP"
                width="100%"
                height="80px"
                frameborder="0"
                allowfullscreen
                allow="payment"
              ></iframe>
            </div>
          </div>

          <div v-else>
            <div
              v-if="contentTxtBas && !isSafariWeb"
              class="mt-1 mb-3"
              v-html="contentTxtBas"
            ></div>
            <div class="d-flex flex-column align-items-center align-items-md-start">
              <iframe
                v-show="isApplePayBtnActive()"
                id="iframePaysafeJS"
                :key="'ap-' + methodePaiement"
                title="iFrame Paysafe JS"
                :src="iframeSrcJS"
                width="100%"
                height="80px"
                frameborder="0"
                allowfullscreen
                allow="payment"
              ></iframe>
              <b-button
                v-if="!isApplePayBtnActive()"
                type="submit"
                variant="primaire"
                class="w-auto px-4 py-1 mx-0 mb-2"
                :disabled="invalid || isSubmitted || !montant"
                :class="{ valid: !invalid }"
              >
                <div class="d-inline-flex w-auto">
                  <div v-if="isSubmitted" class="mr-1">
                    <b-spinner small :label="$t('chargement')"></b-spinner>
                  </div>
                  <span
                    class="text-white"
                    v-html="
                      methodePaiement === CONSTANT.methodePaiement.et.paymentMethod && !isSafariWeb
                        ? content.libOuvrirVirementInterac
                        : content.libBoutonContinuer
                    "
                  ></span>
                  <svg-icon
                    v-if="
                      methodePaiement === CONSTANT.methodePaiement.et.paymentMethod && !isSafariWeb
                    "
                    aria-label="share"
                    class="svg-icon-share ml-4px mr-0"
                    icon-name="ic-share"
                  ></svg-icon>
                </div>
              </b-button>
            </div>
          </div>
        </ValidationProvider>
      </b-form>
    </ValidationObserver>

    <!-- ********** -->
    <!-- Argent Web -->
    <!-- ********** -->
    <div v-show="methodePaiement === CONSTANT.methodePaiement.argentWeb.paymentMethod">
      <div v-if="content.txtArgentWebHaut" v-html="content.txtArgentWebHaut"></div>

      <ValidationObserver ref="observer" v-slot="{ handleSubmit, invalid }" tag="div">
        <b-form @submit.stop.prevent="handleSubmit(onSubmit)">
          <ValidationProvider
            ref="validateur"
            v-slot="validationContext"
            :name="content.libCodeArgentWeb"
            :rules="`required|is_code_argent_web_valid`"
            tag="div"
          >
            <b-form-group
              :label="content.libArgentWebCode"
              label-for="codeArgentWeb"
              class="col-md-10 ml-n2"
            >
              <b-form-input
                id="codeArgentWeb"
                ref="couponWeb"
                v-model="codeArgentWeb"
                trim
                type="text"
                autocomplete="off"
                :class="{
                  'is-invalid':
                    validationContext.errors.length > 0 &&
                    validationContext.errors[0] !== 'MSG00-03' &&
                    validationContext.errors[0] !== 'MSG00-04',
                }"
                @blur.native="forceValidate()"
              ></b-form-input>
              <ErreurValidation
                v-if="validationContext.errors[0] && validationContext.errors[0] !== 'MSG00-04'"
                id="codeArgentWeb-invalid-feedback"
                :message="validationContext.errors[0]"
                :variables="variablesARemplacer"
              ></ErreurValidation>
            </b-form-group>
          </ValidationProvider>
          <div class="text-center text-md-left py-1">
            <b-button
              type="submit"
              variant="primaire"
              class="btn w-auto hauteur px-4 mb-2"
              :disabled="invalid || isSubmitted"
              :class="{ valid: !invalid }"
            >
              <div class="d-inline-flex w-auto">
                <div v-if="isSubmitted" class="mr-1">
                  <b-spinner small :label="$t('chargement')"></b-spinner>
                </div>
                <span class="text-white" v-html="content.libArgentWebBoutonDeposer"></span>
              </div>
            </b-button>
          </div>
          <!-- <span @click.capture="preventClickRetourDepot">
            <Hyperlien
              class="text-center text-sm-left mb-2 mt-n1"
              :content="contentRetourDepot"
            ></Hyperlien>
          </span> -->
        </b-form>
      </ValidationObserver>

      <span @click.prevent="changeMethodePaiement(null)">
        <Hyperlien
          class="mt-0 mb-1 align-items-center text-md-left text-center"
          :content="contentLienAutreModeDepot"
        ></Hyperlien>
      </span>

      <div v-if="content.txtArgentWebBas" v-html="content.txtArgentWebBas"></div>

      <Hyperlien
        v-if="!mixinEnvironnement_inAppMobile && contentLienAideArgentWeb"
        class="lien-aide text-left ml-0 mt-0 mr-0"
        :content="contentLienAideArgentWeb"
      ></Hyperlien>
    </div>

    <!-- ********************** -->
    <!-- INTERAC ENVOI DE FONDS -->
    <!-- ********************** -->
    <div v-show="methodePaiement === CONSTANT.methodePaiement.es.paymentMethod">
      <div v-if="isPremierPaiementES" class="row">
        <div class="col">
          <Paragraphe
            :content="{
              richText: content.txtEnvoiDeFondsExplication,
            }"
          ></Paragraphe>
          <Titre
            :content="{
              type: 'titre',
              titre: content.titreInfoVirement,
              classeCSS: 'mb-2 pt-1',
            }"
            :class="{ 'text-center': $isMobile() }"
          >
          </Titre>
          <Paragraphe
            :content="{
              richText: content.txtEnvoiDeFonds,
            }"
          ></Paragraphe>
        </div>
      </div>

      <div v-else class="row">
        <div class="col">
          <Titre
            :content="{
              type: 'titre',
              titre: content.titreInfoVirementEnCours,
              classeCSS: 'mb-2 pt-1',
            }"
            :class="{ 'text-center': $isMobile() }"
          >
          </Titre>
        </div>
      </div>

      <div class="es-info">
        <div class="row px-1">
          <div class="col-2 ml-0 py-1 px-0">
            <span v-html="$i18n.t('compte.depot.virementInteracEnvoi.libCourriel')"></span>
          </div>
          <div class="col-9 ml-0">
            <strong>{{ esPayment.lqEmail }}</strong>
          </div>
          <div class="col-1 ml-0 px-0 justify-right">
            <BoutonCopier :content="{ textToCopy: esPayment.lqEmail }"></BoutonCopier>
          </div>
        </div>
        <div class="row px-1">
          <div class="col-2 ml-0 py-1 px-0">
            <span v-html="$i18n.t('compte.depot.virementInteracEnvoi.libMessage')"></span>
          </div>
          <div class="col-9 ml-0">
            <strong>{{ esPayment.paymentRef }}</strong>
          </div>
          <div class="col-1 ml-0 px-0 justify-right">
            <BoutonCopier :content="{ textToCopy: esPayment.paymentRef }"></BoutonCopier>
          </div>
          <div class="col-2 ml-0 px-0 attention">
            <span>i</span>
          </div>
          <div
            class="col-10 ml-0 note"
            v-html="$i18n.t('compte.depot.virementInteracEnvoi.noteMessage')"
          ></div>
        </div>
        <div class="row px-1">
          <div class="col-2 ml-0 py-1 px-0">
            <span v-html="$i18n.t('compte.depot.virementInteracEnvoi.libMontant')"></span>
          </div>
          <div class="col-9 ml-0">
            <strong>{{ esPayment.montantEsFormat }}</strong>
          </div>
          <div class="col-1 ml-0 px-0 justify-right">
            <BoutonCopier :content="{ textToCopy: esPayment.mantantEsBrut }"></BoutonCopier>
          </div>
          <div class="col-2 ml-0 px-0 attention">
            <span>i</span>
          </div>
          <div
            class="col-10 ml-0 note"
            v-html="$i18n.t('compte.depot.virementInteracEnvoi.noteMontant')"
          ></div>
        </div>
      </div>
    </div>

    <!-- ***************** -->
    <!-- Paiement Factures -->
    <!-- ***************** -->
    <div v-show="methodePaiement === CONSTANT.methodePaiement.paiementFactures.paymentMethod">
      <Paragraphe :content="{ richText: content.txtPaiementFacture }"></Paragraphe>
    </div>

    <span
      v-show="
        methodePaiement &&
        methodePaiement !== CONSTANT.methodePaiement.argentWeb.paymentMethod &&
        methodePaiement !== CONSTANT.methodePaiement.es.paymentMethod
      "
      @click.prevent="changeMethodePaiement(null)"
    >
      <Hyperlien
        class="mt-0 mb-1 align-items-center align-items-md-start text-md-left text-center"
        :content="contentLienAutreModeDepot"
      ></Hyperlien>
    </span>

    <span
      v-if="!productSource"
      v-show="methodePaiement && methodePaiement === CONSTANT.methodePaiement.es.paymentMethod"
      @click.prevent="esRetourMethodeDepot()"
    >
      <Hyperlien
        class="mt-0 mb-1 align-items-center align-items-md-start text-md-left text-center"
        :content="contentLienAutreModeDepot"
      ></Hyperlien>
    </span>

    <span v-show="methodePaiement && methodePaiement === CONSTANT.methodePaiement.es.paymentMethod">
      <!-- Hyperlien lienRetourProductSource -->
      <Hyperlien
        v-if="productSource"
        class="mt-0 mb-1 align-items-center align-items-md-start text-md-left text-center"
        :content="contentLienRetourProductSourceEs"
      ></Hyperlien>
      <Hyperlien
        v-else
        class="mt-0 mb-1 align-items-center align-items-md-start text-md-left text-center"
        :content="contentEsAccueil"
      ></Hyperlien>
    </span>

    <!-- z-order="999" nécessaire pour l'affichage de l'IFrame quand on clique sur le bouton submit par la méthode showHideIframe() -->
    <div
      v-show="false"
      id="modalPaysafe"
      ref="modalPaysafe"
      class="modal"
      :class="{ 'mt-3': mixinEnvironnement_inAppMobile }"
      role="dialog"
      z-order="999"
    >
      <iframe
        id="iframePaysafe"
        title="iFrame Paysafe"
        :src="iframeSrc"
        width="100%"
        height="100%"
        frameborder="0"
        allowfullscreen
      ></iframe>
    </div>

    <!-- Fenêtre modale ET (Virement INTERAC) uniquement pour Safari Web-->
    <b-modal
      id="modaleETSafariWeb"
      body-class="py-5 px-4 compteClair"
      centered
      hide-header-close
      no-hide-backdrop
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
      hide-header
    >
      <div>
        <div v-if="contentTxtBas" class="mt-1 mb-3" v-html="contentTxtBas"></div>

        <div class="d-flex flex-column align-items-center align-items-md-start">
          <b-button
            type="submit"
            variant="primaire"
            class="btn btn-primaire boutonPrimaire w-auto px-3 py-1 mx-0 mb-2"
            :href="etRedirectUrl"
            target="_blank"
            @click.stop="fermerModaleETSafariWeb()"
          >
            <div class="d-inline-flex w-auto mt-4px">
              <span class="text-white" v-html="content.libOuvrirVirementInterac"></span>
              <svg-icon
                aria-label="share"
                class="svg-icon-share ml-4px mr-0"
                icon-name="ic-share"
              ></svg-icon>
            </div>
          </b-button>
        </div>
      </div>
    </b-modal>

    <!-- Fenêtre modale ET (Virement INTERAC) -->
    <b-modal
      id="modaleET"
      body-class="py-5 px-4 compteClair"
      centered
      hide-header-close
      no-hide-backdrop
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
      hide-header
    >
      <div>
        <Titre
          :content="{
            type: 'titre',
            titre: content.libModaleETTitre,
            classeCSS: 'mb-2 pt-1',
          }"
          :class="{ 'text-center': $isMobile() }"
        >
        </Titre>

        <div v-if="content.txtModaleETHaut" v-html="content.txtModaleETHaut"></div>

        <div class="d-flex flex-column align-items-center">
          <!-- Hyperlien lienRetourProductSource -->
          <Hyperlien
            v-if="productSource"
            class="mt-0 mb-0 align-items-center text-center"
            :content="contentLienRetourProductSource"
          ></Hyperlien>
          <!-- Hyperlien lienPrimaire, aussi saisir le lien pour jouer? -->
          <Hyperlien
            v-else
            class="mt-0 mb-0 align-items-center text-center"
            :content="contentLibModaleETJouerMaintenant"
          ></Hyperlien>
        </div>

        <!-- Hyperlien lienSecondaire, aussi saisir le lien pour jouer? -->
        <Hyperlien class="mt-0 mb-5 text-center" :content="contentLienVoirMonCompte"></Hyperlien>

        <div v-if="content.txtModaleETBas" v-html="content.txtModaleETBas"></div>
        <span @click.prevent="fermerModaleET()">
          <Hyperlien
            class="mt-0 mb-2 text-center"
            :content="contentLienRetournerPageDepot"
          ></Hyperlien>
        </span>
      </div>
    </b-modal>

    <!-- Astuce pour ouvrir un navigateur externe dans l'App iOS (et Android) -->
    <!-- eslint-disable-next-line vuejs-accessibility/anchor-has-content -->
    <a id="aHrefEtRedirectUrl" aria-hidden="true" :href="etRedirectUrl" class="d-none">&nbsp;</a>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { VMoney } from 'v-money';
import Inputmask from 'inputmask';
import Cookies from 'js-cookie';
import platform from 'platform';

import i18n from '@/js/i18n';
import { bus } from '@/main';

// Components
import ErreurValidation from '@/components/formulaire/compte/ErreurValidation';

import Hyperlien from '@/components/base/Hyperlien';
import MessageMel from '@/components/base/MessageMel';
import Separateur from '@/components/base/Separateur';
import Titre from '@/components/base/Titre.vue';
import Paragraphe from '@/components/base/Paragraphe.vue';
import BoutonCopier from '@/components/base/BoutonCopier.vue';

// Helpers
import {
  getCurrentLanguage,
  inAppMobile,
  inEditor,
  removeCurrentLanguage,
  isJelMobile,
} from '@/helpers/AppHelpers';
import { gtmCustomEventByVendor } from '@/helpers/ConsentHelpers';
import MessageHelpers from '@/helpers/MessageHelpers';
import { PageMapping } from '@/helpers/PageMappingHelpers';
import {
  isProductSourceInQueryParams,
  getProductSourceFromQueryParams,
} from '@/helpers/ProductSourceHelpers';
import { returnToHome } from '@/helpers/RouteHelpers';
import { formatNombreEnMonetaire, capitalizeFirstLetter } from '@/helpers/StringHelpers';

// Mixins
import { mixinEnvironnement } from '@/mixins/mixinEnvironnement';
import mixinMessageErreur from '@/mixins/mixinMessageErreur';

// Services
import depotService from '@/services/api/compte/depot';
import session from '@/services/api/compte/session';
import { obtenirSiteIds } from '@/services/api/compte/sites';

// Router & store
import router from '@/router';
import store from '@/store';

const POLLING_MAX_ATTEMPTS = 30;
const POLLING_INTERVAL_MS = 2000;

export default {
  name: 'FormulaireDepot',

  components: {
    ErreurValidation,
    ValidationObserver,
    ValidationProvider,
    Hyperlien,
    MessageMel,
    Separateur,
    Titre,
    Paragraphe,
    BoutonCopier,
  },
  directives: {
    money: VMoney,
  },
  mixins: [mixinEnvironnement, mixinMessageErreur],
  props: { content: { type: Object, required: true } },
  i18n: {
    messages: {
      fr: {
        messageComponent: {
          avec: 'avec',
          spinnerAchalandage: 'En raison d’un achalandage plus élevé qu’à l’habitude, des délais supplémentaires peuvent s’appliquer au traitement des dépôts. Nous regrettons les inconvénients et vous remercions de votre compréhension.',
        },
      },
      en: {
        messageComponent: {
          avec: 'with',
          spinnerAchalandage: 'Due to higher-than-usual traffic, additional delays may apply to deposit processing. We regret any inconvenience and thank you for your understanding.',
        },
      },
    },
  },
  data() {
    return {
      CONSTANT: {
        methodePaiement: {
          card: { paymentMethod: 'Cards', hashFr: 'carte', hashEn: 'card' },
          et: {
            paymentMethod: 'ET',
            hashFr: 'virement-interac',
            hashEn: 'interac-e-transfer',
          },
          es: {
            paymentMethod: 'ES',
            hashFr: 'virement-interac-info',
            hashEn: 'interac-e-transfer-info',
          },
          ap: {
            paymentMethod: 'ApplePay',
            hashFr: 'apple-pay',
            hashEn: 'apple-pay',
          },
          gp: {
            paymentMethod: 'GooglePay',
            hashFr: 'google-pay',
            hashEn: 'google-pay',
          },
          argentWeb: {
            paymentMethod: 'ArgentWeb',
            hashFr: 'coupon-argent-web',
            hashEn: 'argent-web-ticket',
          },
          paiementFactures: {
            paymentMethod: 'PaiementFactures',
            hashFr: 'paiement-facture',
            hashEn: 'bill-payment',
          },
        },
        urlIframe: 'secure/ipaye',
        urlIframeJS: 'secure/ap-paye',
        urlIframeGP: 'secure/gp-paye',
      },

      methodePaiement: null,

      etRedirectUrl: null,

      productSource: getProductSourceFromQueryParams(),
      codeArgentWeb: this.getVoucherFromQueryParams(),

      isErreurServeur: false,
      message: null,
      messageErreur: null,
      isPaiementES: false,
      isPremierPaiementES: false,

      contentMessageMel: {
        message: null,
      },

      isTooltipVirementInteracVisible: true,
      isTooltipApplePayVisible: true,
      isTooltipGooglePayVisible: true,

      iframeDomain: '',
      iframeSrc: '',

      isSpinnerVisible: false,
      spinnerLongWait: false,
      spinnerLongWaitTimeoutId: null,
      isSubmitted: false,

      // Devra être computed sur store
      variablesARemplacer: {
        minLength: null,
      },

      mask: 'VVVV-VVVV-VVVV-VVVV-V',
      codeArgentWebMaskOriginal: {
        mask: '*{4}-*{4}-*{4}-*{4}-*{1}',
        definitions: {
          '*': {
            validator: '[a-zA-Z]|[0-9]',
            casing: 'upper',
          },
        },
        showMaskOnHover: false,
        clearIncomplete: false,
        autoUnmask: true,
      },

      // Polling variables
      _pollingInterval: POLLING_INTERVAL_MS,
      _pollingAttempts: 0,
      _maxPollingAttempts: POLLING_MAX_ATTEMPTS,
      _currentPaymentHandleId: null,

      // 3DS modal variables
      _current3DSHandler: null,
      _current3DSOverlay: null,

      showGooglePay: false,
    };
  },
  computed: {
    ...mapState(['depot']),
    ...mapState(['aide']),
    ...mapGetters('depot', [
      'depositInfo',
      'depotMinimum',
      'depotMaximum',
      'etStatus',
      'esStatus',
      'esPayment',
      'isDepotBloque',
      'webcashWeeklyLimitAmount',
      'billPaymentAccountNumber',
      'isCreditCardAttemptsReached',
      'isWebCashAttemptsReached',
      'isDepositLimitReached',
      'iswebcashWeeklyLimitAmountReached',
    ]),
    montant: {
      get() {
        return this.depot.montant;
      },
      set(value) {
        store.commit('depot/SET_DEPOT_MONTANT', value);
      },
    },

    inAppMobile() {
      return inAppMobile();
    },

    isCreditCardDisabled() {
      return this.isDepositLimitReached || this.isCreditCardAttemptsReached || this.isErreurServeur;
    },
    isETransferDisabled() {
      return (
        this.isDepositLimitReached ||
        this.etStatus !== 'YES' ||
        this.isErreurServeur ||
        this.content.indDesactivationVirementInterac === 'true'
      );
    },
    isETransferESDisabled() {
      return (
        this.isDepositLimitReached ||
        this.esStatus !== 'YES' ||
        this.isErreurServeur ||
        this.content.indDesactivationVirementInteracES === 'true'
      );
    },
    iseTransferLimiteReached() {
      return (this.isDepositLimitReached && this.esStatus === 'YES') || this.isErreurServeur;
    },
    isApplePayDisabled() {
      return (
        this.isDepositLimitReached ||
        this.isErreurServeur ||
        this.content.indDesactivationApplePay === 'true'
      );
    },
    isGooglePayDisabled() {
      return (
        this.isDepositLimitReached ||
        this.isErreurServeur ||
        this.content.indDesactivationGooglePay === 'true'
      );
    },

    isPaiementFacturesDisabled() {
      return (
        this.isDepositLimitReached ||
        this.isErreurServeur ||
        this.content.indDesactivationPaiementFactures === 'true'
      );
    },

    isArgentWebDisabled() {
      if (this.depositInfo) {
        return (
          this.iswebcashWeeklyLimitAmountReached ||
          this.isWebCashAttemptsReached ||
          this.isErreurServeur
        );
      }
      // Profil non chargé à l'ouverture de la page: la limite par défaut (500) s'applique
      return this.isErreurServeur;
    },
    variablesRemplacementMinMax() {
      return {
        limiteMinDepot: formatNombreEnMonetaire(this.depotMinimum, 2),
        limiteMaxDepot: formatNombreEnMonetaire(this.depotMaximum, 2),
      };
    },

    variablesRemplacementArgentWeb() {
      return {
        webcashWeeklyLimitAmount: formatNombreEnMonetaire(this.webcashWeeklyLimitAmount, 2),
      };
    },

    isMessageErreur() {
      return this.messageErreur?.details;
    },
    messageErreurCreditCard() {
      if (this.depositInfo) {
        if (this.isCreditCardAttemptsReached) {
          return i18n.t('validations.messages.depot.nombreTentativesMaximales');
        }
      }
      return null;
    },
    messageErreurETransfer() {
      if (this.depositInfo) {
        if (this.etStatus === 'NO') {
          return i18n.t('validations.messages.depot.virementInteracIntedit');
        }
        // etStatus peut être 'UNKNOWN'
        if (this.etStatus !== 'YES' || this.content.indDesactivationVirementInterac === 'true') {
          return i18n.t('validations.messages.depot.virementInteracAucunStatut');
        }
      }
      return null;
    },
    messageErreurETransferES() {
      if (this.depositInfo) {
        if (this.esStatus === 'NO') {
          return i18n.t('validations.messages.depot.virementInteracESIntedit');
        }
        // etStatus peut être 'UNKNOWN'
        if (this.esStatus !== 'YES' || this.content.indDesactivationVirementInteracES === 'true') {
          return i18n.t('validations.messages.depot.virementInteracESAucunStatut');
        }
      }
      return null;
    },
    messageErreurApplePay() {
      if (this.depositInfo) {
        if (this.content.indDesactivationApplePay === 'true') {
          return i18n.t('validations.messages.depot.applePayDesactive');
        }
      }
      return null;
    },
    messageErreurGooglePay() {
      if (this.depositInfo) {
        if (this.content.indDesactivationGooglePay === 'true') {
          return i18n.t('validations.messages.depot.googlePayDesactive');
        }
      }
      return null;
    },
    messageErreurArgentWeb() {
      if (this.depositInfo) {
        if (this.isWebCashAttemptsReached) {
          return i18n.t('validations.messages.depot.nombreTentativesMaximalesWebCash');
        }
        if (this.iswebcashWeeklyLimitAmountReached) {
          return i18n.t('validations.messages.depot.atteintLimiteWebCash');
        }
      }
      return null;
    },

    contentTitreDepot() {
      let title;
      if (this.methodePaiement === this.CONSTANT.methodePaiement.card.paymentMethod) {
        title = this.content.titreCarteDebitCredit;
      } else if (this.methodePaiement === this.CONSTANT.methodePaiement.ap.paymentMethod) {
        title = this.content.libApplePay;
      } else if (this.methodePaiement === this.CONSTANT.methodePaiement.gp.paymentMethod) {
        title = this.content.libGooglePay;
      } else if (this.methodePaiement === this.CONSTANT.methodePaiement.et.paymentMethod) {
        title = this.content.libVirementInterac;
      } else if (this.methodePaiement === this.CONSTANT.methodePaiement.es.paymentMethod) {
        title = this.content.libVirementInteracES;
      } else if (this.methodePaiement === this.CONSTANT.methodePaiement.argentWeb.paymentMethod) {
        title = this.content.libCouponArgentWeb;
      } else if (
        this.methodePaiement === this.CONSTANT.methodePaiement.paiementFactures.paymentMethod
      ) {
        title = this.content.libPaiementFactures;
      } else {
        title = this.content.titreDepot;
      }

      return {
        titre: title,
        type: 'grandTitre',
      };
    },

    contentTxtHaut() {
      return this.getContentTxt('haut');
    },

    contentTxtBas() {
      return this.getContentTxt('bas');
    },

    contentLienCouponArgentWeb() {
      if (inAppMobile()) {
        return {
          texte: this.content.libCouponArgentWeb,
          type: 'lienTertiaire',
          lien: {
            field: 'lienExterne',
            lienExterne: 'app://action/scanWebCash',
          },
        };
      }
      return {
        texte: this.content.libCouponArgentWeb,
        type: 'lienTertiaire',
        lien: {
          field: 'lienExterne',
          lienExterne: '#',
        },
      };
    },
    contentLienPaiementFactures() {
      return {
        texte: this.content.libPaiementFactures,
        type: 'lienTertiaire',
        lien: {
          field: 'lienExterne',
          lienExterne: '#',
        },
      };
    },
    contentLienAideBulleVirementInterac() {
      if (!this.content.libLienBulleVirementInterac) {
        return null;
      }
      return {
        texte: this.content.libLienBulleVirementInterac,
        type: 'aide',
        idQuestion: this.content.idLienBulleVirementInterac,
        lien: {
          field: 'aide',
          idAide: this.content.idLienBulleVirementInterac,
        },
      };
    },
    contentLienAideBulleApplePay() {
      if (!this.content.libLienBulleApplePay) {
        return null;
      }
      return {
        texte: this.content.libLienBulleApplePay,
        type: 'aide',
        idQuestion: this.content.idLienBulleApplePay,
        lien: {
          field: 'aide',
          idAide: this.content.idLienBulleApplePay,
        },
      };
    },
    contentLienAideBulleGooglePay() {
      if (!this.content.libLienBulleGooglePay) {
        return null;
      }
      return {
        texte: this.content.libLienBulleGooglePay,
        type: 'aide',
        idQuestion: this.content.idLienBulleGooglePay,
        lien: {
          field: 'aide',
          idAide: this.content.idLienBulleGooglePay,
        },
      };
    },
    contentLienAideCredit() {
      if (!this.content.libAideCredit) {
        return null;
      }
      return {
        texte: this.content.libAideCredit,
        type: 'aide',
        idQuestion: this.content.idQuestionCredit,
        lien: {
          field: 'aide',
          idAide: this.content.idQuestionCredit,
        },
      };
    },
    contentLienAideApplePay() {
      if (!this.content.libAideApplePay) {
        return null;
      }
      return {
        texte: this.content.libAideApplePay,
        type: 'aide',
        idQuestion: this.content.idQuestionApplePay,
        lien: {
          field: 'aide',
          idAide: this.content.idQuestionApplePay,
        },
      };
    },
    contentLienAideGooglePay() {
      if (!this.content.libAideGooglePay) {
        return null;
      }
      return {
        texte: this.content.libAideGooglePay,
        type: 'aide',
        idQuestion: this.content.idQuestionGooglePay,
        lien: {
          field: 'aide',
          idAide: this.content.idQuestionGooglePay,
        },
      };
    },
    contentLienAideArgentWeb() {
      if (!this.content.libArgentWebAide) {
        return null;
      }
      return {
        texte: this.content.libArgentWebAide,
        type: 'aide',
        idQuestion: this.content.idQuestionArgentWeb,
        lien: {
          field: 'aide',
          idAide: this.content.idQuestionArgentWeb,
        },
      };
    },
    contentLienAutreModeDepot() {
      return {
        texte: this.content.libChoisirAutreModeDepot,
        type: 'lienSecondaire',
        lien: {
          field: 'lienExterne',
          lienExterne: '#',
        },
      };
    },
    contentLienRetourProductSource() {
      return {
        texte: this.content.libBoutonContinuer,
        type: 'boutonPrimaire',
        lien: {
          field: 'lienRetourProductSource',
          typeProductSource: 'URLRetourDepot',
        },
      };
    },
    contentLienRetourProductSourceEs() {
      return {
        texte: i18n.t('lienRetour'),
        type: 'boutonPrimaire',
        lien: {
          field: 'lienRetourProductSource',
          typeProductSource: 'URLRetourDepot',
        },
      };
    },
    contentLibModaleETJouerMaintenant() {
      return {
        texte: this.content.libModaleETJouerMaintenant,
        type: 'boutonPrimaire',
        lien: this.content.lienModaleETJouerMaintenant,
      };
    },
    contentEsAccueil() {
      return {
        texte: this.content.libAccueil,
        type: 'lienSecondaire',
        lien: this.content.lienAccueil,
      };
    },
    contentLienVoirMonCompte() {
      return {
        texte: this.content.libModaleETVoirMonCompte,
        type: 'lienSecondaire',
        lien: this.content.lienModaleETVoirMonCompte,
      };
    },
    contentLienRetournerPageDepot() {
      return {
        texte: this.content.libModaleETRetournerPageDepot,
        type: 'lienSecondaire',
        lien: {
          field: 'lienExterne',
          lienExterne: '#',
        },
      };
    },
    contentLienAccueil() {
      return {
        texte: i18n.t('lienRetourAccueil'),
        type: 'lienSecondaire',
        lien: {
          field: 'lienExterne',
          lienExterne: '/',
        },
      };
    },

    isSafariWeb() {
      return platform.name == 'Safari' && !inAppMobile();
    },
  },
  watch: {
    $route(to, from) {
      this.methodePaiement = this.initMethodePaiement(to.hash);
    },
    methodePaiement(newMethod, oldMethod) {
      // Nettoyer l'ancien iframe
      if (oldMethod === this.CONSTANT.methodePaiement.ap.paymentMethod) {
        this.showHideIframe('iframePaysafeJS', 'none');
      } else if (oldMethod === this.CONSTANT.methodePaiement.gp.paymentMethod) {
        this.showHideIframe('iframePaysafeGP', 'none');
      }

      // Afficher le nouveau
      this.$nextTick(() => {
        if (newMethod === this.CONSTANT.methodePaiement.ap.paymentMethod) {
          this.showHideIframe('iframePaysafeJS', 'block');
        } else if (newMethod === this.CONSTANT.methodePaiement.gp.paymentMethod) {
          this.showHideIframe('iframePaysafeGP', 'block');
        }
      });
    },
  },
  async beforeMount() {
    // Efface les messages de dépôt du store
    store.commit('profile/RESET_MESSAGES');
    // Force le refresh du ProfileDetails
    store.commit('profile/RESET_PROFILE_DETAILS');
    this.montant = null;

    // Argent Web
    this.variablesARemplacer.minLength = this.getCouponWebMinLength();

    this.iframeSrc = this.getUrlIframe(this.CONSTANT.urlIframe);
    // Contrainte ApplePay, le iframe doit etre sur le meme domaine de la pageweb
    this.iframeSrcJS = this.getUrlIframeOnSameDomain(this.CONSTANT.urlIframeJS);
    this.showHideIframe('iframePaysafeJS', 'none');

    // iFrame Google Pay
    this.iframeSrcGP = this.getUrlIframeOnSameDomain(this.CONSTANT.urlIframeGP);
    this.showHideIframe('iframePaysafeGP', 'none');

    //this.showSpinner();
    //await this.obtenirPaymentProfile();
    //hotfixe webcach
    if (inAppMobile()) {
      const coupon = this.getVoucherFromQueryParams();
      if (coupon) {
        this.voucherMobileAppCheck(coupon);
      }
    }
  },
  created() {
    // Avec Vue Router
    this.showGooglePay = this.$route.query.hlgp === 'true';
  },
  mounted() {
    this.methodePaiement = this.initMethodePaiement(window.location.hash);

    // Fix 3DSecure zoom sur iPhone
    this.setViewport();

    // Ajoute un EventListener 'resize'
    window.addEventListener('resize', this.setViewport);
    // Ajoute iFrame Paysafe EventListener sur post message
    window.addEventListener('message', this.depotEventListener);
    window.addEventListener('message', this.depotApplePayEventListener);
    window.addEventListener('message', this.depotGooglePayEventListener);

    // Ajout du mask sur l'input du coupon ArgentWeb
    Inputmask(this.codeArgentWebMaskOriginal).mask(document.getElementById('codeArgentWeb'));

    // 2023-04-04 TODO: A retirer si inutile
    // Argent Web
    // const msg = store.getters['message/getMessagesFlash'][0];
    // if (msg) {
    //   bus.$emit('afficherMessage', msg);
    // }

    if (this.codeArgentWeb) {
      this.methodePaiement = this.CONSTANT.methodePaiement.argentWeb.paymentMethod;
    }

    if (!inEditor) {
      this.gererCookieBulleAide('VirementInterac');
      this.gererCookieBulleAide('ApplePay');
      this.gererCookieBulleAide('GooglePay');
    }
  },
  beforeDestroy() {
    // Supprime l'eventListener sur 'resize'
    window.removeEventListener('resize', this.setViewport);
    // Supprime iFrame Payse EventListener sur post message
    window.removeEventListener('message', this.depotEventListener);
    window.removeEventListener('message', this.depotApplePayEventListener);
    window.removeEventListener('message', this.depotGooglePayEventListener);
    this.hideSpinnerLongWait();
  },
  methods: {
    // Affiche le spinner avec le texte "Chargement".
    showSpinner() {
      this.isSpinnerVisible = true;
    },
    // Masque le spinner. N'affecte pas le timer/texte d'achalandage :
    // utiliser hideSpinnerLongWait() pour l'arrêter explicitement.
    hideSpinner() {
      this.isSpinnerVisible = false;
    },
    // Arme le timer d'achalandage : après 10 s d'affichage continu, le texte du spinner
    // bascule sur le message d'achalandage. À appeler uniquement pour un init deposit
    // réellement en cours (cf. initPaysafeDeposit).
    showSpinnerLongWait() {
      // Réinitialise au cas où une session précédente aurait laissé le flag à true
      this.spinnerLongWait = false;
      // Évite d'empiler plusieurs timers si rappelé sans hideSpinnerLongWait()
      if (this.spinnerLongWaitTimeoutId) {
        clearTimeout(this.spinnerLongWaitTimeoutId);
      }
      // Après 10 s, bascule le texte; l'ID est mis à null pour signaler qu'aucun timer n'est en attente
      this.spinnerLongWaitTimeoutId = setTimeout(() => {
        this.spinnerLongWait = true;
        this.spinnerLongWaitTimeoutId = null;
      }, 10000);
    },
    // Annule le timer d'achalandage et remet le texte par défaut
    hideSpinnerLongWait() {
      this.spinnerLongWait = false;
      if (this.spinnerLongWaitTimeoutId) {
        clearTimeout(this.spinnerLongWaitTimeoutId);
        this.spinnerLongWaitTimeoutId = null;
      }
    },
    setViewport() {
      // Fix 3DSecure zoom sur iPhone
      if (/iPhone/i.test(navigator.userAgent)) {
        const changeWindowSize = 375;
        let viewportContent =
          'width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=1.0,user-scalable=yes';
        if (window.innerWidth < changeWindowSize) {
          viewportContent = `width=${changeWindowSize},user-scalable=no,viewport-fit=cover`;
        }
        document.querySelector("meta[name='viewport']").setAttribute('content', viewportContent);
      }
    },

    initMethodePaiement(hash) {
      let methodePaiement = null;

      if (hash) {
        const cleanHash = hash.replace('#', '');
        // Valider que le hash est valide
        const result = Object.keys(this.CONSTANT.methodePaiement).find((key) =>
          this.$i18n.locale == 'en'
            ? this.CONSTANT.methodePaiement[key].hashEn === cleanHash
            : this.CONSTANT.methodePaiement[key].hashFr === cleanHash
        );
        if (result) {
          this.cacherTooltip('VirementInterac');
          this.cacherTooltip('ApplePay');
          this.cacherTooltip('GooglePay');
          methodePaiement = this.CONSTANT.methodePaiement[result].paymentMethod;
        } else if (this.aide.listeQuestionsReponses?.some((element) => element.name === cleanHash))
          methodePaiement = this.methodePaiement;
      }
      return methodePaiement;
    },

    changeMethodePaiement(newMethodePaiement) {
      // Clear error messages when changing payment method
      this.contentMessageMel.message = null;

      if (newMethodePaiement?.paymentMethod !== this.CONSTANT.methodePaiement.es.paymentMethod) {
        this.montant = null;
        this.isPremierPaiementES = false;
      }

      // Cacher TOUS les iframes avant de changer de méthode
      this.showHideIframe('iframePaysafeJS', 'none');
      this.showHideIframe('iframePaysafeGP', 'none');

      this.methodePaiement = newMethodePaiement ? newMethodePaiement.paymentMethod : null;

      // Le profil n'est plus chargé à l'ouverture de la page; on le charge au choix du virement Interac
      // ou du paiement de factures
      if (
        newMethodePaiement?.paymentMethod === this.CONSTANT.methodePaiement.et.paymentMethod ||
        newMethodePaiement?.paymentMethod ===
          this.CONSTANT.methodePaiement.paiementFactures.paymentMethod
      ) {
        this.showSpinner();
        this.obtenirPaymentProfile();
      }

      const hashLocale = this.$i18n.locale == 'en' ? 'hashEn' : 'hashFr';

      if (
        !inAppMobile() &&
        newMethodePaiement?.paymentMethod !== this.CONSTANT.methodePaiement.argentWeb.paymentMethod
      ) {
        this.cacherTooltip('VirementInterac');

        // Argent Web
        if (
          newMethodePaiement?.paymentMethod ===
          this.CONSTANT.methodePaiement.argentWeb.paymentMethod
        ) {
          // Valide le profile du client en provenance de l'Application Mobile
          // avant de le rediriger vers le scan du coupon Argent Web
          // 'scanWebCash' sur l'Application Mobile
          this.aiguillageDepotArgentWeb();
        }

        if (this.isApplePayBtnActive()) {
          this.showHideIframe('iframePaysafeJS', 'block');
        }

        if (this.isGooglePayBtnActive()) {
          this.showHideIframe('iframePaysafeGP', 'block');
        }

        const hashContent = newMethodePaiement ? newMethodePaiement[hashLocale] : '';

        this.$router.push({
          hash: hashContent,
          query: this.$route.query,
        });
      }
    },

    esRetourMethodeDepot() {
      depotService.obtenirInfoDepot().then((response) => {
        this.$router.push({
          hash: '',
          query: this.$route.query,
        });
      });
    },

    obtenirPaymentProfile() {
      depotService
        .obtenirInfoDepot()
        .then((response) => {
          if (this.depositInfo) {
            if (this.methodePaiement === this.CONSTANT.methodePaiement.argentWeb.paymentMethod) {
              this.aiguillageDepotArgentWeb();
            } else {
              // On redirige vers la page de dépôt non autorisé si les conditions sont atteintes
              this.aiguillageDepot();
            }
            this.hideSpinner();
          } else {
            // TODO: Optimiser la récupération des messages
            MessageHelpers.obtenirMessage('MSG01', this.$root)
              .then((msgResp) => {
                this.contentMessageMel.message = this.modifierMessage(msgResp.msgDetail);
              })
              .catch((error) => {
                console.error('Erreur de récupération du message!', error);
              });
            this.isErreurServeur = true;
            this.hideSpinner();
          }
        })

        .catch((error) => {
          this.hideSpinner();
          console.log('obtenirInfoDepot | failed', error);
          if (error.url) {
            this.redirectToPage(error.url, error.message);
          } else {
            this.redirectToErrorPage();
          }
        });
    },

    aiguillageDepot() {
      // Limite de dépôt partiellement atteinte
      if (this.isDepositLimitReached && !this.iswebcashWeeklyLimitAmountReached) {
        this.recupererMessage('MSG04-55', true);
      }

      this.hideSpinner();
    },

    aiguillageDepotArgentWeb() {
      // TODO: Confirmer avec Nicole que ceci est déjà fait au départ
      // if (
      //   this.isDepotBloque ||
      //   (this.depositInfo.webcashAllowDeposit === false && this.depositInfo.webcashPayMethodId)
      // ) {
      //   // Dépôt ArgentWeb bloqué.
      //   this.recupererMessage('MSG04-50', false, true, PageMapping.DEPOT_NON_AUTORISE.siteUrl);
      // } else
      if (this.iswebcashWeeklyLimitAmountReached) {
        // Limite dépôt par ArgentWeb atteinte.
        this.recupererMessage(
          'MSG04-30',
          false,
          true,
          PageMapping.DEPOT_ARGENT_WEB_NON_AUTORISE.siteUrl
        );
      } else if (this.isWebCashAttemptsReached) {
        // Nombre tentatives ArgentWeb en échec pour la journée courante atteint.
        this.recupererMessage(
          'MSG04-3-21',
          false,
          true,
          PageMapping.DEPOT_ARGENT_WEB_NON_AUTORISE.siteUrl
        );
      } else {
        const coupon = this.getVoucherFromQueryParams();
        if (coupon) {
          this.voucherMobileAppCheck(coupon);
        }
      }
    },

    // Fix pour les performances
    voucherMobileAppCheck(coupon) {
      // Utilisé pour les appels mobile App
      if (coupon && inAppMobile()) {
        const couponArgentWeb = coupon.replace(new RegExp(/-/, 'g'), '');
        this.codeArgentWeb = couponArgentWeb;
        // Vérfieir si le coupon est valide
        const regexCouponArgentWeb = new RegExp('(1|8|9)', 'i');
        const isCouponWebInvalide = couponArgentWeb.match(regexCouponArgentWeb);
        if (!isCouponWebInvalide && couponArgentWeb.length === this.variablesARemplacer.minLength) {
          this.processDepotArgentWeb(coupon).catch((error) => {
            console.log(error);
          });
        } else {
          this.recupererMessage('MSG04-3-25', true);
        }
      }
    },

    // Le code de coupon ne peut venir que du mobile
    // On ignore toute autre provenance
    getVoucherFromQueryParams() {
      if (!inAppMobile()) {
        return '';
      }

      const query = { ...this.$route.query };
      const couponArgentWeb = query.voucher;

      if (!couponArgentWeb) {
        return '';
      }

      return couponArgentWeb;
    },

    formatteCoupon(value) {
      if (!value) return value;
      const regEx = /(\w{0,4})(\w{0,4})(\w{0,4})(\w{0,4})(\w{0,1})/;
      const replacedInput = value.match(regEx);
      let formattedValue = '';
      for (let i = 1; i <= 5; i++) {
        if (replacedInput[i]) {
          if (i === 1) {
            formattedValue += `${replacedInput[i]}`;
          } else {
            formattedValue += `-${replacedInput[i]}`;
          }
        }
      }
      return formattedValue;
    },

    getDomainIframe() {
      return process.env.VUE_APP_IFRAME_SECURE;
    },

    getUrlIframe(path) {
      this.iframeDomain = this.getDomainIframe();
      const lang = getCurrentLanguage();
      return `${this.iframeDomain}/${lang}/${path}`;
    },

    getUrlIframeOnSameDomain(path) {
      const lang = getCurrentLanguage();
      return `${process.env.VUE_APP_PROXY_URL_POD}/${lang}/${path}`;
    },

    depotEventListener(event) {
      if (event.origin === this.iframeDomain && event.data) {
        switch (event.data.etat) {
          case 'Error':
            this.removePayIframe(event.data);
            this.redirectToErrorPage();
            break;
          case 'BeforePayment':
          case 'DuringPayment':
            // Ferme la modale
            this.removePayIframe(event.data);
            this.hideSpinner();
            break;
          case 'AfterPayment':
            this.removePayIframe(event.data);
            this.redirectToPage(PageMapping.DEPOT_CONFIRMATION.siteUrl);
            break;
          case 'CardNotification':
            this.cardsNotification(event.data);
            break;
          case 'DepositCard':
            if (event.data.token) {
              this.processDeposit(event.data);
            }
            break;
          default:
            break;
        }
      }
    },

    // Puisqu'il fait le iframe Apple soit sur le meme domaine que la page parent
    depotApplePayEventListener(event) {
      if (event.origin !== window.location.origin || !event.data) return;
      const { etat, token } = event.data;
      if (event.origin === window.location.origin && event.data) {
        switch (event.data.etat) {
          case 'InitApplePayDeposit':
            if (
              this.depotMinimum <= this.montant.replace(',', '.') &&
              this.montant.replace(',', '.') <= this.depotMaximum
            ) {
              this.initPaysafeDeposit();
            }
            break;
          case 'ErrorApplePay':
            this.redirectToErrorPage();
            break;
          case 'DepositApplePay':
            if (event.data.token) {
              this.processDeposit(event.data);
            }
            break;
          default:
            break;
        }
      }
    },

    // Puisqu'il faut que le iframe Google soit sur le même domaine que la page parent
    depotGooglePayEventListener(event) {
      if (event.origin !== window.location.origin || !event.data) return;
      const { etat, token } = event.data;
      if (event.origin === window.location.origin && event.data) {
        switch (event.data.etat) {
          case 'InitGooglePayDeposit':
            if (
              this.depotMinimum <= this.montant.replace(',', '.') &&
              this.montant.replace(',', '.') <= this.depotMaximum
            ) {
              this.initPaysafeDeposit();
            }
            break;
          case 'OPEN_3DS_CHALLENGE':
            console.log('Ouverture du 3DS Challenge:', event.data.url);
            this.show3DSChallenge(event.data.url);
            this.startPollingPaymentHandle(event.data.paymentHandleId);
            break;
          case 'CLOSE_3DS_CHALLENGE':
            // Fermer le modal 3DS
            this.close3DSChallenge();
            break;
          case 'DepositGooglePay':
            if (event.data.googlePay) {
              this.processGooglePayDeposit(event.data);
            }
            break;
          case 'ErrorGooglePay':
            this.redirectToErrorPage();
            break;
          default:
            break;
        }
      }
    },

    cardsNotification(oData) {
      depotService.cardsNotification(oData);
    },

    onlyNumbers($event) {
      const keyCode = $event.keyCode ? $event.keyCode : $event.which;
      // On accepte les touches numériques '0-9' et les séparateurs de décimale ',' ou '.'
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 44 && keyCode !== 46) {
        // 46 is dot and 44 is comma
        $event.preventDefault();
      }
    },

    // Argent Web
    getCouponWebMinLength() {
      const pattern = /-/;
      const couponWebMinLength = this.mask.replace(new RegExp(pattern, 'g'), '').length;
      return couponWebMinLength;
    },

    async forceValidate() {
      await this.$refs.observer.validate();
    },

    detecterCookieTooltip(nomTooltip) {
      return (
        Cookies.get(`afficherInfoBulle${nomTooltip}`) ||
        inAppMobile() ||
        !this.content[`txtBulle${nomTooltip}`]
      );
    },

    ecrireCookieTooltip(nomTooltip) {
      // Cookie de session
      // eslint-disable-next-line no-undef
      ejApi.ecrireCookie(`afficherInfoBulle${nomTooltip}`, false);
    },
    cacherTooltip(TooltipToHide) {
      this[`isTooltip${TooltipToHide}Visible`] = false;
    },

    async onSubmit() {
      if (this.isSubmitted) {
        return;
      }
      /*
       * On reset les messages d'Erreur Serveur lors du submit du formulaire
       * Si il y a une erreur affichée
       * Spécifications: https://lotoquebec.atlassian.net/browse/PECOMM-197
       */
      this.messageErreur = null;
      this.contentMessageMel.message = null;

      this.isSubmitted = true;

      if (
        this.methodePaiement === this.CONSTANT.methodePaiement.et.paymentMethod ||
        this.methodePaiement === this.CONSTANT.methodePaiement.es.paymentMethod
      ) {
        this.processDepositeTransfer();
      } else if (this.methodePaiement === this.CONSTANT.methodePaiement.argentWeb.paymentMethod) {
        this.submitCouponArgentWeb().catch(() => {
          this.isSubmitted = false;
          throw { message: this.messageErreur };
        });
      } else {
        // CONSTANT.methodePaiement.card et CONSTANT.methodePaiement.io
        this.initPaysafeDeposit();
      }
    },

    showHideIframe(id, styleDisplay, displayInline) {
      const node = document.getElementById(id);
      if (node) {
        if (styleDisplay) {
          node.style.display = styleDisplay;
        } else if (node.style.display == 'none') {
          node.style.display = displayInline ? 'inline' : 'block';
        } else {
          node.style.display = 'none';
        }
      }
    },
    fermerModaleETSafariWeb() {
      this.$bvModal.hide('modaleETSafariWeb');
      this.$bvModal.show('modaleET');
    },
    fermerModaleET() {
      // Rafraîchissement complet afin de mettre à jour depositInfo
      // et ainsi permettre à nouveau le Virement Interac s'il a fonctionné entre temps.
      this.changeMethodePaiement(null);
      window.location.reload();
    },

    ejPostMessageToApplePayIframe(message) {
      const ifr = document.getElementById('iframePaysafeJS');
      ifr.contentWindow.postMessage(message, ifr.src);
    },

    ejPostMessageToGooglePayIframe(message) {
      const ifr = document.getElementById('iframePaysafeGP');
      ifr.contentWindow.postMessage(message, ifr.src);
    },

    ejPostMessage(message) {
      const payIframe = document.getElementById('iframePaysafe');
      if (!payIframe) {
        // TODO: Déplacer iframe dans les propriétés au mounted()
        // pour éviter la recréation de l'iFrame
        const iframe = document.createElement('iframe');
        iframe.setAttribute('id', 'iframePaysafe');
        iframe.setAttribute('title', 'iFrame Paysafe');
        iframe.setAttribute('src', this.iframeSrc);
        iframe.setAttribute('width', '100%');
        iframe.setAttribute('height', '100%');
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allowfullscreen', 'allowfullscreen');

        iframe.onload = function () {
          const ifr = document.getElementById('iframePaysafe');
          ifr.contentWindow.postMessage(message, ifr.src);
        };
        document.getElementById('modalPaysafe').appendChild(iframe);
      } else {
        payIframe.contentWindow.postMessage(message, payIframe.src);
      }
      if (message.status === 'INITCARD' || message.status === 'INITINTERAC') {
        // Ouvrir la modale seulement lors de l'init
        this.showHideIframe('modalPaysafe', 'block');
      }
    },

    removePayIframe(data) {
      // Fermer proprement l'instance checkout paysafe et applePay iframe
      data.status = 'INSTANCETOCLOSE';
      data = JSON.parse(JSON.stringify(data));
      if (this.methodePaiement === this.CONSTANT.methodePaiement.ap.paymentMethod) {
        this.ejPostMessageToApplePayIframe(data.status);
      } else if (this.methodePaiement === this.CONSTANT.methodePaiement.gp.paymentMethod) {
        this.ejPostMessageToGooglePayIframe(data.status);
      } else {
        const payIframe = document.getElementById('iframePaysafe');
        this.iframeSrc = payIframe.src;
        if (payIframe) {
          payIframe.contentWindow.postMessage(data, payIframe.src);
          // Détruire l'instance
          document.getElementById('modalPaysafe').removeChild(payIframe);
        }
        // Fermer la modale
        this.showHideIframe('modalPaysafe', 'none');
      }
      // Désactiver le spinner sur le bouton
      this.isSubmitted = false;
    },

    /**
     *
     * - Appel du service depot.initPaysafeDeposit() => Card et IO
     * - Vérification du code retour (Status)
     *   pour rediriger vers la bonne page (Erreur)
     *   ou lancer le checkout vers l'IFrame
     *
     */
    async initPaysafeDeposit() {
      this.showSpinner();
      this.showSpinnerLongWait();
      const oData = {
        paymentType: this.methodePaiement,
        amount: this.montant.replace(',', '.'), // Décimales
      };

      depotService
        .initPaysafeDeposit(oData)
        .then((response) => {
          this.hideSpinnerLongWait();
          if (response.data && response.data.status === 'ERROR') {
            this.hideSpinner();
            this.isSubmitted = false;
            if (response.data.msg === 'CONNEXION') {
              session.fermerSession().then(() => {
                returnToHome();
              });
            } else if (
              ['MSG04-10', 'MSG04-11', 'MSG04-15', 'MSG04-20'].includes(response.data.msg)
            ) {
              // on met à jour les infos de dépôt avant d'afficher le message d'erreur
              if (response.data.depositInfo) {
                // this.updateDepositInfo(response.data.depositInfo);
                store.commit('depot/SET_DEPOSIT_INFO', response.data.depositInfo);
              }
              this.recupererMessage(response.data.msg, true);
              this.hideSpinner();
            } else {
              if (['MSG04-50'].includes(response.data.msg) && response.data.depositInfo) {
                // on met à jour les infos de dépôt avant de redireger vers la page d'erreur
                // this.updateDepositInfo(response.data.depositInfo);
                store.commit('depot/SET_DEPOSIT_INFO', response.data.depositInfo);
              }
              this.redirectToErrorPage(response.data.msg);
            }
          } else if (
            response.data.status === 'SUCCESS' &&
            (response.data.cardDeposit.status === 'INITCARD' ||
              response.data.cardDeposit.status === 'INITINTERAC')
          ) {
            this.ejPostMessage(response.data.cardDeposit);
          } else if (
            response.data.status === 'SUCCESS' &&
            response.data.cardDeposit.status === 'DEPOSIT_APPLEPAY'
          ) {
            this.ejPostMessageToApplePayIframe(response.data.cardDeposit);
          } else if (
            response.data.status === 'SUCCESS' &&
            response.data.cardDeposit.status === 'DEPOSIT_GOOGLEPAY'
          ) {
            this.ejPostMessageToGooglePayIframe(response.data.cardDeposit);
          } else if (response.data.status === 'global-error') {
            console.error('initPaysafeDeposit | fail: ', response.data.msg);
            this.redirectToErrorPage(response.data.msg);
          } else if (response.data.connexion === 'invalide') {
            // Specifique au dépot a cause du mobile-app
            this.resolveReturningPage();
          }
        })
        .catch((error) => {
          this.hideSpinner();
          this.hideSpinnerLongWait();
          console.error('initPaysafeDeposit | fail: ', error);
          this.redirectToErrorPage();
        });
    },

    /**
     *
     * - Appel du service depot.getGooglePayInfo()
     * pour initier le bouton google pay.
     *
     */
    async getGooglePayInfo() {
      this.showSpinner();
      const montantDepot = this.montant.replace(',', '.');

      depotService.getGooglePayInfo().then((response) => {
        if (response.data && response.data.status === 'ERROR') {
          this.hideSpinner();
          this.isSubmitted = false;
          if (response.data.msg === 'CONNEXION') {
            session.fermerSession().then(() => {
              returnToHome();
            });
          } else {
            this.recupererMessage(response.data.msg, true);
            this.hideSpinner();
          }
        } else if (
          response.data.status === 'SUCCESS' &&
          response.data.googlePayInfo.status === 'DEPOSIT_GOOGLEPAY'
        ) {
          response.data.googlePayInfo.montant = montantDepot;
          this.ejPostMessageToGooglePayIframe(response.data.googlePayInfo);
        }
      });
    },

    async processDepositeTransfer() {
      const eData = {
        paymentMethod: this.isPaiementES
          ? this.CONSTANT.methodePaiement.es.paymentMethod
          : this.methodePaiement,
        amount: parseFloat(this.montant.replace(',', '.')) * 100, // En cents
      };

      depotService
        .processDeposit(eData)
        .then((response) => {
          if (response.data.status === 'SUCCESS') {
            if (response.data?.cardDeposit?.paymentReference) {
              this.changeMethodePaiement(this.CONSTANT.methodePaiement.es);
            } else {
              this.digestETResponse(response.data);
            }
            this.isSubmitted = false;
            this.isPaiementES = false;
          } else if (response.data.status === 'ERROR') {
            console.error('processDepositeTransfer | failed', response.data);
            if (response.data.depositInfo) {
              store.commit('depot/SET_DEPOSIT_INFO', response.data.depositInfo);
            }
            // Specifique au dépot à cause du mobile-app
            if (response.data.connexion === 'invalide') {
              this.redirectToErrorPage(response.data.msg);
            } else if (response.data.msg === 'CONNEXION') {
              session.fermerSession().then(() => {
                returnToHome();
              });
            } else {
              this.redirectToErrorPage(response.data.msg);
              this.isSubmitted = false;
              this.isPaiementES = false;
            }
          }
        })
        .catch((error) => {
          console.error('processDepositeTransfer | fail: ', error);
          this.recupererMessage('MSG01');
          this.isSubmitted = false;
          this.isPaiementES = false;
        });
    },

    async digestETResponse(data) {
      if (data.cardDeposit.redirectUrl) {
        // Ajout datalayer pour Google Analytics
        gtmCustomEventByVendor(process.env.VUE_APP_IAB_ID_ANALYTICS, {
          event: 'ga-depot',
          montant: data.cardDeposit.amount,
        });

        this.etRedirectUrl = data.cardDeposit.redirectUrl;
        if (inAppMobile()) {
          // Astuce pour ouvrir un navigateur externe dans l'App iOS (et Android)
          this.$nextTick(() => {
            document.getElementById('aHrefEtRedirectUrl').click();
          });
        } else if (this.isSafariWeb) {
          // Dans Safari, ouverture dans la même fenêtre pour éviter une fenêtre bloquante
          this.$bvModal.show('modaleETSafariWeb');
        } else {
          window.open(data.cardDeposit.redirectUrl, '_blank');
          this.$bvModal.show('modaleET');
        }
      } else {
        console.error('processDepositeTransfer | fail: redirectUrl manquant');
        this.recupererMessage('MSG01', true);
      }
    },

    async processDeposit(eData) {
      // this.montant = null;
      this.showSpinner();
      depotService
        .processDeposit(eData)
        .then((response) => {
          if (response.data.status === 'SUCCESS') {
            // Ajout datalayer pour Google Analytics
            gtmCustomEventByVendor(process.env.VUE_APP_IAB_ID_ANALYTICS, {
              event: 'ga-depot',
              montant: this.montant,
            });

            this.redirectToPage(PageMapping.DEPOT_CONFIRMATION.siteUrl);
            this.removePayIframe(response.data);
          } else if (response.data.status === 'ERROR') {
            console.error('processDeposit | failed', response.data);
            if (response.data.depositInfo) {
              store.commit('depot/SET_DEPOSIT_INFO', response.data.depositInfo);
            }
            // Specifique au dépot à cause du mobile-app
            if (response.data.connexion === 'invalide') {
              this.montant = null;
              this.redirectToErrorPage(response.data.msg);
              this.removePayIframe(response.data);
            } else if (response.data.msg === 'CONNEXION') {
              this.montant = null;
              session.fermerSession().then(() => {
                this.removePayIframe(response.data);
                returnToHome();
              });
            } else if (this.isCreditCardAttemptsReached) {
              this.removePayIframe(response.data);
              this.recupererMessage(response.data.msg);
              this.hideSpinner();
              this.changeMethodePaiement(null);
            } else {
              this.recupererMessage(response.data.msg);
              this.hideSpinner();
            }
          }
        })
        .catch((error) => {
          console.error('processDeposit | fail: ', error);
          this.recupererMessage('MSG01');
          this.hideSpinner();
        });
    },

    async processGooglePayDeposit(eData) {
      // this.montant = null;
      this.showSpinner();
      depotService
        .processGooglePayDeposit(eData)
        .then((response) => {
          if (response.data.status === 'SUCCESS') {
            // Ajout datalayer pour Google Analytics
            gtmCustomEventByVendor(process.env.VUE_APP_IAB_ID_ANALYTICS, {
              event: 'ga-depot',
              montant: this.montant,
            });

            this.redirectToPage(PageMapping.DEPOT_CONFIRMATION.siteUrl);
            this.removePayIframe(response.data);
          } else if (response.data.status === 'ERROR') {
            console.error('processGooglePayDeposit | failed', response.data);
            if (response.data.depositInfo) {
              store.commit('depot/SET_DEPOSIT_INFO', response.data.depositInfo);
            }
            // Specifique au dépot à cause du mobile-app
            if (response.data.connexion === 'invalide') {
              this.montant = null;
              this.redirectToErrorPage(response.data.msg);
              this.removePayIframe(response.data);
            } else if (response.data.msg === 'CONNEXION') {
              this.montant = null;
              session.fermerSession().then(() => {
                this.removePayIframe(response.data);
                returnToHome();
              });
            } else if (this.isCreditCardAttemptsReached) {
              this.removePayIframe(response.data);
              this.recupererMessage(response.data.msg);
              this.hideSpinner();
              this.changeMethodePaiement(null);
            } else {
              this.recupererMessage(response.data.msg);
              this.hideSpinner();
            }
          }
        })
        .catch((error) => {
          console.error('processGooglePayDeposit | fail: ', error);
          this.recupererMessage('MSG04-6-10');
          this.hideSpinner();
        });
    },

    async getGPPaymentHandle(eData) {
      depotService
        .getGPPaymentHandle(eData)
        .then((response) => {
          if (response.data.status === 'SUCCESS') {
            // this.redirectToPage(PageMapping.DEPOT_CONFIRMATION.siteUrl);
            // this.removePayIframe(response.data);
            store.commit('depot/SET_PAYMENTHANDLE_ID', response.data.id);
            this.checkPaymentHandleStatus(response.data);
          } else if (response.data.status === 'ERROR') {
            console.error('getGPPaymentHandle | failed', response.data);
            if (response.data.depositInfo) {
              store.commit('depot/SET_DEPOSIT_INFO', response.data.depositInfo);
            }
            // Specifique au dépot à cause du mobile-app
            if (response.data.connexion === 'invalide') {
              this.montant = null;
              this.redirectToErrorPage(response.data.msg);
              this.removePayIframe(response.data);
            } else if (response.data.msg === 'CONNEXION') {
              this.montant = null;
              session.fermerSession().then(() => {
                this.removePayIframe(response.data);
                returnToHome();
              });
            } else if (this.isCreditCardAttemptsReached) {
              this.removePayIframe(response.data);
              this.recupererMessage(response.data.msg);
              this.hideSpinner();
              this.changeMethodePaiement(null);
            } else {
              this.recupererMessage(response.data.msg);
              this.hideSpinner();
            }
          }
        })
        .catch((error) => {
          console.error('processDeposit | fail: ', error);
          this.recupererMessage('MSG01');
          this.hideSpinner();
        });
    },

    checkPaymentHandleStatus(paymentHandleData) {
      if (paymentHandleData.status === 'PAYABLE') {
        console.log(paymentHandleData);
        this.processDeposit(paymentHandleData);
      } else if (paymentHandleData.status === 'FAILED') {
        console.log('PAYMENT HANDLE ERROR');
      } else if (paymentHandleData.status === 'INITIATED') {
        console.log('PaymentHandle initiated = 3DS challenge');
        this.initiate3dsChallenge(paymentHandleData);
      }
    },

    // Argent Web
    async submitCouponArgentWeb() {
      if (!this.codeArgentWeb) {
        return;
      }

      const codeArgentWebFormatte = this.formatteCoupon(this.codeArgentWeb);

      // Vérfier si le coupon est valide
      const isCodeArgentWebInvalide = codeArgentWebFormatte.match(/(1|8|9)/);

      if (!isCodeArgentWebInvalide) {
        this.processDepotArgentWeb(codeArgentWebFormatte).catch((error) => {
          console.log('processDepotArgentWeb', error);
        });
      }
      this.isSubmitted = false;
    },

    // TODO: Optimiser le processus du Voucher
    // Fix pour les performances
    async processDepotArgentWeb(couponArgentWeb) {
      this.showSpinner();
      depotService
        .depotArgentWeb(couponArgentWeb)
        .then((response) => {
          this.hideSpinner();
          if (response.data && response.data.status == 'SUCCESS') {
            this.montant = response.data.voucherDeposit.amount;

            this.redirectToPage(PageMapping.DEPOT_CONFIRMATION.siteUrl);
          } else if (response.data.msg === 'CONNEXION') {
            session.fermerSession().then(() => {
              returnToHome();
            });
          } else {
            if (response.data && response.data.connexion == 'invalide') {
              // Specifique au dépot à cause du mobile-app
              this.resolveReturningPage();
            }
            if (response.data && ['GLOBAL_ERROR', 'ERROR'].includes(response.data.status)) {
              if (response.data.depositInfo) {
                store.commit('depot/SET_DEPOSIT_INFO', response.data.depositInfo);
              }

              if (this.isWebCashAttemptsReached) {
                // Nombre tentatives ArgentWeb en échec pour la journée courante atteint.
                this.recupererMessage(
                  'MSG04-3-21',
                  false,
                  true,
                  PageMapping.DEPOT_ARGENT_WEB_NON_AUTORISE.siteUrl
                );
              } else {
                // On reset le code du coupon sauf si on reste dans la page pour permettre au joueur de réessayer.
                switch (response.data.msg) {
                  case 'MSG04-35':
                  case 'MSG04-50':
                    this.recupererMessage(
                      response.data.msg,
                      false,
                      true,
                      PageMapping.DEPOT_NON_AUTORISE.siteUrl
                    );
                    break;
                  case 'MSG04-30':
                  case 'MSG04-3-21':
                    this.recupererMessage(
                      response.data.msg,
                      false,
                      true,
                      PageMapping.DEPOT_ARGENT_WEB_NON_AUTORISE.siteUrl
                    );
                    break;
                  case 'MSG04-15':
                  case 'MSG04-3-15':
                  case 'MSG04-3-20':
                  case 'MSG04-3-25':
                  case 'MSG04-3-30':
                  case 'MSG04-3-40':
                    this.recupererMessage(response.data.msg, true);
                    break;
                  default:
                    // Incluant 'MSG04-3-50'
                    this.redirectToErrorPage(response.data.msg);
                    break;
                }
              }
            }
          }
        })
        .catch((error) => {
          console.log('processDepotArgentWeb | fail', error);
          this.hideSpinner();
          if (error.url) {
            this.redirectToPage(error.url);
          } else {
            this.redirectToErrorPage();
          }
        });
      return true;
    },

    redirectToErrorPage(msgCode = null) {
      this.redirectToPage(PageMapping.ERREUR_DEPOT_CARTE.siteUrl, msgCode);
    },

    redirectToPage(url, msgCode = null) {
      let redirectUrl = url;
      const currentLanguage = getCurrentLanguage();
      const urlParams = new URLSearchParams(window.location.search);

      if (urlParams.get('voucher') && redirectUrl.indexOf(PageMapping.DEPOT.siteUrl) > -1) {
        // Supprime le paramètre voucher pour les redirections.
        urlParams.delete('voucher');
        // Reconstruit l'url de redirection sans le QueryParam 'voucher'
        redirectUrl = `${url}?${urlParams.toString()}`;
        router.push(redirectUrl).catch(() => {});
      } else {
        if (msgCode) {
          store.commit('message/ADD_MESSAGE_FLASH', msgCode);
        }
        redirectUrl = removeCurrentLanguage(redirectUrl, currentLanguage);
        // Redirige vers url passée
        const uriReturn = store.getters['routes/getUrlFromWebsitePath'](redirectUrl);
        router.push(uriReturn).catch(() => {});
      }
    },

    resolveReturningPage() {
      return isProductSourceInQueryParams('MA_LT') ? this.redirectURLProductSource() : '';
    },

    redirectURLProductSource() {
      obtenirSiteIds()
        .then((response) => {
          if (response && response.data.URLRetourDepot) {
            window.location.href = response.data.URLRetourDepot;
          }
        })
        .catch((error) => {
          if (error.url) {
            throw error.url;
          }
          throw { url: PageMapping.ERREUR_GENERIQUE.siteUrl };
        });
    },

    isApplePayBtnActive() {
      return (
        this.jel_applePayActif() &&
        this.methodePaiement === this.CONSTANT.methodePaiement.ap.paymentMethod
      );
    },

    isGooglePayBtnActive() {
      return this.methodePaiement === this.CONSTANT.methodePaiement.gp.paymentMethod;
    },

    async recupererMessage(
      msgCode,
      afficherErreur = false,
      sauverMessage = false,
      redirectUrl = null
    ) {
      // Si applePay ou googlepay nous affichons les messages dans la page de dépôt
      if (
        this.methodePaiement === this.CONSTANT.methodePaiement.ap.paymentMethod ||
        this.methodePaiement === this.CONSTANT.methodePaiement.gp.paymentMethod
      ) {
        afficherErreur = true;
      }

      // On récupère le message pour l'afficher dans l'iFrame Paysafe
      MessageHelpers.obtenirMessage(msgCode, this.$root)
        .then((msgResp) => {
          const msg = {
            title: msgResp.msgTitre,
            details: this.modifierMessage(msgResp.msgDetail),
          };
          if (afficherErreur) {
            this.contentMessageMel.message = msg?.details;
          } else if (sauverMessage) {
            if ([PageMapping.DEPOT_NON_AUTORISE.siteUrl].includes(redirectUrl)) {
              store.commit('profile/SET_MESSAGE_DEPOT', msg);
            } else if ([PageMapping.DEPOT_ARGENT_WEB_NON_AUTORISE.siteUrl].includes(redirectUrl)) {
              store.commit('profile/SET_MESSAGE_VOUCHER', msg);
            }
          } else {
            this.ejPostMessage({ messages: msg });
          }

          return msgResp;
        })
        .catch((error) => {
          console.log('Erreur de récupération du message', error);
        })
        .finally(() => {
          if (
            [
              PageMapping.DEPOT_NON_AUTORISE.siteUrl,
              PageMapping.DEPOT_ARGENT_WEB_NON_AUTORISE.siteUrl,
            ].includes(redirectUrl)
          ) {
            this.redirectToPage(redirectUrl);
          } else if (redirectUrl) {
            this.redirectToPage(redirectUrl, msgCode);
          }
        });
    },
    // Messages provenant de l'app message sont encapsulées dans des spans.
    // Changement des balises pour uniformiser le padding des affichages
    modifierMessage(message) {
      let pattern = '';
      message = MessageHelpers.nettoyerMessageSpanP(message);
      if (message.includes('{{min}}')) {
        pattern = /{{min}}/;
        message = message.replace(
          new RegExp(pattern, 'gm'),
          formatNombreEnMonetaire(this.depotMinimum, 2)
        );
      }
      if (message.includes('{{max}}')) {
        pattern = /{{max}}/;
        message = message.replace(
          new RegExp(pattern, 'gm'),
          formatNombreEnMonetaire(this.depotMaximum, 2)
        );
      }
      if (message.includes('{{webcashWeeklyLimitAmount}}')) {
        pattern = /{{webcashWeeklyLimitAmount}}/;
        message = message.replace(
          new RegExp(pattern, 'gm'),
          formatNombreEnMonetaire(this.webcashWeeklyLimitAmount, 2)
        );
      }
      return message;
    },

    contentLibTexteConseil(texteConseil) {
      const pattern = /<[\\/]?p>/g;
      return texteConseil.replace(new RegExp(pattern), '');
    },
    getContentTxt(emplacement) {
      let texte = '';
      if (this.methodePaiement === this.CONSTANT.methodePaiement.card.paymentMethod) {
        texte = this.content[`txtCarteExplication${capitalizeFirstLetter(emplacement)}`];
      } else if (this.methodePaiement === this.CONSTANT.methodePaiement.et.paymentMethod) {
        texte = this.content[`txtVirementInteracExplication${capitalizeFirstLetter(emplacement)}`];
      } else if (!this.methodePaiement) {
        texte = this.content[`txtDepot${capitalizeFirstLetter(emplacement)}`];
      }

      return texte;
    },

    gererCookieBulleAide(methodePaiement) {
      if (
        // Ne pas utiliser isETransferDisabled puisque ETStatus est undefined lors du mounted
        this.detecterCookieTooltip(methodePaiement) ||
        this.content[`indDesactivation${methodePaiement}`] === 'true'
      ) {
        this.cacherTooltip(methodePaiement);
      } else {
        this.ecrireCookieTooltip(methodePaiement);
      }
    },

    initierPaiementES() {
      this.isPaiementES = true;
      this.isPremierPaiementES = true;
      this.onSubmit();
    },

    show3DSChallenge(challengeUrl) {
      this.cleanup3DSModal();

      // Overlay bloquant (pas de fermeture possible en cliquant dessus)
      const overlay = document.createElement('div');
      overlay.id = 'lq-googlepay-threeds-overlay';
      overlay.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.85);
        z-index: 999999;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        transition: opacity 0.3s ease;
      `;

      // Container minimaliste
      const modalContainer = document.createElement('div');
      modalContainer.style.cssText = `
        background: white;
        width: 100%;
        max-width: 500px;
        height: auto;
        max-height: 90vh;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        transform: scale(0.95);
        transition: transform 0.3s ease;
        position: relative;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
      `;

      // Spinner de chargement
      const loader = document.createElement('div');
      loader.style.cssText = `
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 40px;
        height: 40px;
        border: 4px solid #f3f3f3;
        border-top: 4px solid #667eea;
        border-radius: 50%;
        animation: lq-threeds-spin 1s linear infinite;
        z-index: 1;
      `;

      // Styles CSS
      if (!document.getElementById('lq-threeds-modal-styles')) {
        const style = document.createElement('style');
        style.id = 'lq-threeds-modal-styles';
        style.textContent = `
          @keyframes lq-threeds-spin {
            0% { transform: translate(-50%, -50%) rotate(0deg); }
            100% { transform: translate(-50%, -50%) rotate(360deg); }
          }
          body.lq-threeds-modal-open {
            overflow: hidden !important;
            position: fixed !important;
            width: 100% !important;
          }
          @media (max-width: 768px) {
            #lq-googlepay-threeds-overlay > div {
              width: 100% !important;
              max-width: 100% !important;
              max-height: 100% !important;
              height: 100% !important;
            }
          }
        `;
        document.head.appendChild(style);
      }

      // Iframe 3DS - prend tout l'espace
      const iframe = document.createElement('iframe');
      iframe.id = 'lq-threeds-challenge-iframe';
      iframe.src = challengeUrl;
      iframe.setAttribute('allow', 'payment');
      iframe.style.cssText = `
        width: 100%;
        min-height: 500px;
        height: 100%;
        border: none;
        opacity: 0;
        transition: opacity 0.3s ease;
      `;

      // ============================================
      // NOUVEAU : Compteur de chargements d'iframe
      // ============================================
      let loadCount = 0;

      iframe.addEventListener('load', () => {
        loadCount++;
        console.log(`📊 Iframe load #${loadCount}`);

        if (loadCount === 1) {
          // Premier chargement = Challenge 3DS Paysafe
          console.log('✅ Challenge 3DS chargé');
          loader.style.display = 'none';
          iframe.style.opacity = '1';
        } else if (loadCount === 2) {
          // Deuxième chargement = ReturnLink (page callback)
          console.log('🎯 ReturnLink détecté (masquage iframe)');

          // Masquer immédiatement l'iframe
          iframe.style.opacity = '0';
          iframe.style.display = 'none';

          // Réafficher le loader du modal (optionnel)
          loader.style.display = 'block';

          // Fermer le modal après un court délai
          setTimeout(() => {
            console.log('🚪 Fermeture modal 3DS');
            this.close3DSChallenge();
          }, 500);
        }
      });

      // Gestion des erreurs
      iframe.onerror = (error) => {
        console.error('❌ Erreur chargement iframe:', error);
        this.stopPolling();
        this.close3DSChallenge();
        this.recupererMessage('MSG04-6-20');
      };

      // Assembler - SANS bouton de fermeture
      modalContainer.appendChild(loader);
      modalContainer.appendChild(iframe);
      overlay.appendChild(modalContainer);
      document.body.appendChild(overlay);

      // Bloquer le scroll et les interactions
      document.body.classList.add('lq-threeds-modal-open');

      // Sauvegarder la référence
      this._current3DSOverlay = overlay;

      // Animations
      setTimeout(() => {
        overlay.style.opacity = '1';
        modalContainer.style.transform = 'scale(1)';
      }, 10);

      // PAS de fermeture en cliquant sur l'overlay
      // L'utilisateur DOIT compléter le 3DS ou annuler dans l'iframe
    },

    cleanup3DSModal() {
      if (this._current3DSHandler) {
        window.removeEventListener('message', this._current3DSHandler);
        this._current3DSHandler = null;
      }
      this._current3DSOverlay = null;
    },

    close3DSChallenge() {
      const overlay = this._current3DSOverlay;

      if (!overlay) {
        console.log('Modal 3DS déjà fermé ou non ouvert');
        return;
      }

      const modalContainer = overlay.querySelector('div');

      overlay.style.opacity = '0';
      if (modalContainer) {
        modalContainer.style.transform = 'translateY(30px)';
      }

      // Réactiver le scroll
      document.body.classList.remove('lq-threeds-modal-open');

      setTimeout(() => {
        if (overlay.parentNode) {
          document.body.removeChild(overlay);
        }
        this.cleanup3DSModal();
      }, 300);
    },

    // =============================================================
    // Démarrer le polling du payment handle pour obtenir son statut
    // =============================================================
    async startPollingPaymentHandle(paymentHandleId) {
      console.log('=== DEBUT POLLING PAYMENT HANDLE ===');
      console.log('Payment Handle ID:', paymentHandleId);

      this._currentPaymentHandleId = paymentHandleId;
      this._pollingAttempts = 0;

      // Démarrer le polling immédiatement
      this.pollPaymentHandle(paymentHandleId);

      // Continuer toutes les 2 secondes
      this._pollingInterval = setInterval(() => {
        this.pollPaymentHandle(paymentHandleId);
      }, POLLING_INTERVAL_MS);
    },

    // ========================================
    // NOUVEAU - Polling du payment handle
    // ========================================
    pollPaymentHandle(paymentHandleId) {
      const maxAttempts = this.$data._maxPollingAttempts;
      this._pollingAttempts++;
      console.log(`--- Tentative ${this._pollingAttempts}/${maxAttempts} ---`);

      depotService
        .getGPPaymentHandleById(paymentHandleId)
        .then((response) => {
          const paymentHandle = response.data.googlePayPaymentHandle;
          console.log('Statut actuel:', paymentHandle.status);

          // Vérifier le statut
          if (paymentHandle.status === 'PAYABLE') {
            console.log('Payment handle est PAYABLE');
            console.log('=== FIN POLLING - SUCCES ===');

            this.stopPolling();
            this.close3DSChallenge();

            paymentHandle.etat = 'DepositGooglePay';
            paymentHandle.paymentMethod = 'GooglePay';

            this.processGooglePayDeposit(paymentHandle);
          } else if (paymentHandle.status === 'FAILED') {
            console.log('Payment handle est FAILED');
            this.stopPolling();
            this.close3DSChallenge();

            this.hideSpinner();
            this.recupererMessage('MSG04-6-20');
          } else if (paymentHandle.status === 'EXPIRED') {
            console.log('Payment handle EXPIRED');
            this.stopPolling();
            this.close3DSChallenge();

            this.hideSpinner();
            this.recupererMessage('MSG04-6-20');
          } else if (
            paymentHandle.status === 'INITIATED' ||
            paymentHandle.status === 'PROCESSING'
          ) {
            console.log(`En attente... (${paymentHandle.status})`);

            if (this._pollingAttempts >= maxAttempts) {
              console.error('TIMEOUT: Maximum de tentatives atteint');
              this.stopPolling();
              this.close3DSChallenge();

              this.hideSpinner();
              this.recupererMessage('MSG04-6-20');
            }
          } else {
            console.warn('Statut inattendu:', paymentHandle.status);

            if (this._pollingAttempts >= maxAttempts) {
              this.stopPolling();
              this.close3DSChallenge();

              this.hideSpinner();
              this.recupererMessage('MSG04-6-20');
            }
          }
        })
        .catch((error) => {
          console.error('Erreur lors du polling:', error);

          if (error.response) {
            console.error('Status:', error.response.status);
            console.error('Data:', error.response.data);
          }

          if (this._pollingAttempts >= maxAttempts) {
            console.log('=== FIN POLLING - ERREUR ===');
            this.stopPolling();
            this.close3DSChallenge();

            this.hideSpinner();
            this.recupererMessage('MSG04-6-20');
          }
        });
    },

    // ========================================
    // NOUVEAU - Arrêter le polling
    // ========================================
    stopPolling() {
      if (this._pollingInterval) {
        clearInterval(this._pollingInterval);
        this._pollingInterval = null;
      }
      this._pollingAttempts = 0;
      this._currentPaymentHandleId = null;
    },
  },
};
</script>

<style lang="scss" scoped>
iframe {
  width: 100%;
  border: none;

  #iframePaysafe {
    height: 600px;
  }
}
.es-info {
  border-radius: 16px;
  @media (max-width: 540px) {
    width: auto;
  }
  margin-bottom: 15px;
  padding: 0 10px;

  div:first-child {
    border-radius: 9px 9px 0 0;
  }

  div:last-child {
    border-radius: 0 0 9px 9px;
  }

  .justify-right {
    justify-items: right;
  }

  span {
    font-size: 13px;
  }

  .row {
    margin-bottom: 0.25rem;
    background-color: #e9f6fe;
    padding: 10px 0;
    align-items: center;
  }
}

.attention {
  text-align: right;
  align-self: start;
  span {
    color: white;
    background-color: $couleur-primaire;
    border-radius: 50%;
    height: 16px;
    width: 16px;
    line-height: 16px;
    display: inline-block;
    text-align: center;
  }
}

.encadrer {
  border-style: solid;
  border-width: 1px;
  border-radius: 16px;
  border-color: $couleur-primaire;
  padding: 10px 14px;
  cursor: pointer;
  @media (max-width: 540px) {
    width: auto;
  }
  margin-bottom: 15px;
}

.encadrer[disabled='disabled'] {
  cursor: default;
  border-color: $couleur-bg-spinner-full-screen;
}
.encadrer[disabled='disabled'] span,
.encadrer[disabled='disabled'] div {
  color: $couleur-bg-spinner-full-screen;
}

.texte-radio-btn-depot {
  font-size: 16px;
  line-height: inherit;
  padding-top: 5px;
}

.label_options {
  font-size: 14px;
  font-weight: 500;
}

.encadrer .image-container {
  text-align: right;
}

.encadrer .info {
  font-size: 15px;
}

.is-valid {
  background-color: $couleur-fond-primaire;
  border-color: $couleur-primaire;
}

.is-invalid {
  background-image: unset;
  border-color: $couleur-erreur;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.form-control {
  height: 3rem;
}

.form-control:disabled {
  background-color: #e9ecef;
  opacity: 1;
  color: darkgray;
  border-color: $couleur-bg-spinner-full-screen;
}

.option-paiement {
  font-weight: normal;
  font-family: 'Graphik', Graphik, sans-serif;
  font-size: 20px;
  line-height: 21px;
}

.hyperLien {
  display: inline-block;
  font-size: 12px;
  margin-left: 5px;
  margin-right: 5px;
  padding-top: 0.3rem;
  color: darkblue;
}

.lien-aide {
  margin-left: 48px;
}

.mt-015 {
  margin-top: 0.15rem;
}

.note {
  font-size: 13px;
  line-height: 17px;
}

.texte-invalid {
  margin-left: 3px;
  margin-right: 3px;
  display: inline-block;
  font-weight: bold;
  font-size: 15px;
  color: $couleur-erreur;
}

.texte-padding {
  padding-top: 0.3rem;
}

.texte-tooltip {
  font-size: 14px;
  font-family: 'Graphik_regular', Graphik, sans-serif;
  line-height: 17px;
}

.svg-icon-amex {
  width: 21px;
  height: 25px;
  margin-left: 3px;
}
.svg-icon-mc {
  width: 35px;
  height: 25px;
  margin-right: -3px;
}
.svg-icon-visa {
  width: 40px;
  height: 25px;
}
.svg-icon-small {
  width: 32px;
  height: 32px;
}

.svg-icon-interac {
  width: 32px;
  height: 32px;
  position: relative;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.svg-icon-applepay {
  width: 65px;
  height: 27.5px;
  position: relative;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.svg-icon-googlepay {
  width: 80px;
  height: 45px;
  position: relative;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.svg-icon-argentweb {
  width: 31.2px;
  height: 24px;
  position: relative;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.svg-icon-paiementfactures {
  width: 27.733px;
  height: 26px;
  position: relative;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.svg-icon-desjardins {
  width: 117px;
  height: 33px;
  margin-bottom: 10px;
}

.svg-icon-applepay-big {
  width: 113px;
  height: 48px;
}

.svg-icon-googlepay-big {
  width: 115px;
  height: 70px;
}

.svg-icon-share {
  width: 30px;
  height: 20px;
}

.btn.btn-primaire .svg-icon-share.svg-icon {
  fill: #fff;
  margin-top: -2px;
}

.svg-big-icon-visa {
  height: 65px;
  width: 75px;
}

.svg-big-icon-mc {
  height: 60px;
  width: 60px;
}

.svg-big-icon-amex {
  height: 54px;
  width: 54px;
}

.svg-icon-big {
  height: 55px;
  width: 55px;
}

::v-deep .boutonPrimaire.btn-primaire {
  margin-bottom: 1rem;
  &.btn.btn-product-source,
  &.btn span.lien-interne-externe {
    color: $couleur-blanc;
  }
}

.cursor-default {
  cursor: default;
}

.lienSecondaireSuite {
  padding-top: 5px;
  font-size: 15px;
  line-height: 17px;

  &.disabled {
    color: $couleur-bg-spinner-full-screen;
  }
}

.btn.btn-primaire.disabled::v-deep .spinner-border {
  color: $couleur-blanc;
}

.v-popover {
  height: 0;
}

// Nécessaire pour rendre bouton visible sur Safari
.popover button.close {
  width: 22px;
  height: 22px;
  right: -12px;
}

.font-titre {
  font-family: $font-graphik-semibold;
}

.color-disabled {
  border-color: $couleur-bg-spinner-full-screen;
  color: #797c7e;
  ::v-deep p {
    color: #797c7e;
  }
}

.conteneur-btn-desjardins {
  @media (min-width: 768px) {
    width: fit-content;
  }
  > .disabled {
    background-color: transparent !important;
  }
}

::v-deep .spinner-fullscreen {
  background-color: rgba(0, 0, 0, 0.5);
}

.spinner-card {
  background-color: #ffffff;
  border-radius: 8px;
  min-width: 280px;
  max-width: 600px;
  margin: 32px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
}

.spinner-card-text {
  color: #1f2937;
  font-size: 1rem;
  line-height: 1.4;
}
</style>
